<template>
  <div
    id="dvreg"
    @click="HideDropdown"
    :class="visitor ? 'page-effect visitor' : 'page-effect'"
  >
    <header v-if="!visitor" class="header-navbar sticky-top">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-12 p-0">
            <div class="d-md-flex align-items-center justify-content-between">
              <div class="left-logo" style="width: 100%">
                <img id="imgBanner" v-bind:src="BannerURL" alt="e2m" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
    <section
      class="register-page-wrapper body-content long-form-page"
      style="background-color: #ffffff"
    >
      <div
        v-if="!visitor"
        class="
          d-flex
          justify-content-between
          align-items-center
          top-login-wrapper
          py-2
          px-5
        "
        :class="publicEventCollection ? 'public-reg-wrap' : ''"
      >
        <a
          v-show="!['E1647872860081'].includes(EventsData[0].eventId)"
          href="javascript:void(0);"
          style="display: block"
          v-on:click="goForLandingPage"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="22"
            height="17.94"
            viewBox="0 0 22 17.94"
          >
            <path
              id="back.svg"
              class="cls-1"
              d="M5684,1118.96h-17.45l7.16,6.31a0.96,0.96,0,0,1,0,1.38,0.978,0.978,0,0,1-1.38,0l-8.95-7.93a0.247,0.247,0,0,1-.09-0.04,1.053,1.053,0,0,1,0-1.43,0.631,0.631,0,0,0,.09-0.04l8.95-7.93a0.978,0.978,0,0,1,1.38,0,0.96,0.96,0,0,1,0,1.38l-7.16,6.31H5684A1,1,0,1,1,5684,1118.96Z"
              transform="translate(-5663 -1109)"
            /></svg
          >Go Back
        </a>
        <div class="reg-cownt-down">
          <div class="event-coundown-timer">
            <Countdown deadline="March 31, 2022"></Countdown>
          </div>
        </div>
        <div
          v-show="
            !['E1615533069198', 'E1637947380160', 'E1647872860081'].includes(
              EventsData[0].eventId
            )
          "
          class="top-right-login text-right hdr-btn login-ico"
        >
          <a
            v-if="ShowEventListLink && !publicEventCollection"
            v-on:click="goForEventList"
            class="event-List"
            >Event List</a
          >
          <a v-on:click="goForLogin" class="login">Login</a>
        </div>
      </div>

      <div class="container">
        <!---top back- login area ---->

        <!------->
        <!-----middle-area ------->
        <div class="row mt-5 register-lg-form" style="background: transparent;">
          <!-----left-area ------->
          <div v-if="!visitor" :class="'col-md-4 reg_left_wrapper_hld'+(['E1647872860081', 'E1615533069198'].includes(EventsData[0].eventId)?' reg-left-image-fit-wrap':'')">
            <div
              class="
                register-page-wrapper
                left-content
                event-reg-speakers
                form-left-hld
              "
            >
              <!-- <img v-if="['E1647872860081'].includes(EventsData[0].eventId)" src="https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1612172963673E1647872860081%2FBranding%2FEDulifeSocial1080x1920.png?alt=media" /> -->
              <img v-if="['E1647872860081'].includes(EventsData[0].eventId)" src="https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1612172963673E1647872860081%2FBranding%2Fimage_2022_05_18T11_27_11_152Z.png?alt=media" />
              <img v-else-if="['E1615533069198'].includes(EventsData[0].eventId)" src="https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1612172963673E1615533069198%2FBranding%2Fimage_2022_03_23T10_37_01_648Z.png?alt=media" />
              <h1 v-else class="page-head mb-4">{{ EventsData[0].EventName }}</h1>
                
              <div
                class="top-right-login"
                v-show="
                  ![
                    'E1615533069198',
                    'E1637947380160',
                    'E1647872860081',
                    'E1651675626344',
                  ].includes(EventsData[0].eventId)
                "
              >
                <a
                  href="javascript:void(0);"
                  class="event-List"
                  style="pointer-events: none"
                  >{{ EventsData[0].EventStartDateZ }}&nbsp; - &nbsp;{{
                    EventsData[0].EventEndDateZ
                  }}
                  &nbsp;{{ EventsData[0].EventTimezoneZ }}</a
                >
              </div>
            </div>
          </div>
          <!------register form--------->
          <div class="col-md-8 login-form-hld reg-form-drop">
            <div
              id="dvRegForm"
              v-bind:class="'reg-right-hld mb-3 ' + shortforCSSClass"
            >
              <h3 v-show="!['E1647872860081'].includes(EventsData[0].eventId)">
                Register for the event
              </h3>
              <h3 v-show="['E1647872860081'].includes(EventsData[0].eventId)">
                Enroll Now
              </h3>
              <p class="small-text">
                (<span style="color: red">*</span>) Marked fields are mandatory
                to complete.
              </p>
              <form action="/action_page.php">
                <div class="row form-right-hld">
                  <div class="col-md-12"></div>

                  <div v-show="IsShowSalutation" class="col-md-6">
                    <div class="form-group">
                      <label>{{ salutationDisplayLabel }}</label>
                      <br />
                      <select
                        id="dropsalutation"
                        name="salutation"
                        class="form-control"
                      >
                        <option value="Mr.">Mr.</option>
                        <option value="Ms.">Ms.</option>
                        <option value="Mrs.">Mrs.</option>
                        <option value="Rev.">Rev.</option>
                        <option value="Sr.">Sr.</option>
                        <option value="Dr.">Dr.</option>
                      </select>
                    </div>
                  </div>

                  <div class="col-md-6" v-show="IsShowfName">
                    <div class="form-group">
                      <label>
                        {{ firstNameDisplayLabel }}
                        <span
                          class="required"
                          style="color: red"
                          v-show="IsfNameMandatory"
                          >*</span
                        >
                      </label>
                      <input
                        required
                        type="text"
                        class="form-control"
                        id="txtFName"
                      />
                    </div>
                  </div>
                  <div class="col-md-6" v-show="IsShowlName">
                    <div class="form-group">
                      <label>
                        {{ lastNameDisplayLabel }}
                        <span
                          class="required"
                          style="color: red"
                          v-show="IslNameMandatory"
                          >*</span
                        >
                      </label>
                      <input
                        required
                        type="text"
                        class="form-control"
                        id="txtLName"
                      />
                    </div>
                  </div>
                  <div class="col-md-6" v-show="IsShowProfilePicture">
                    <div class="form-group">
                      <label>
                        {{ ProfilePictureDisplayLabel }}
                        <span
                          class="required"
                          style="color: red"
                          v-show="IsProfilePictureMandatory"
                          >*</span
                        >
                      </label>
                      <input
                        id="fuProfile"
                        class="form-control"
                        type="file"
                        @change="onFileChange"
                        ref="file"
                      />
                    </div>
                  </div>
                  <div class="col-md-6" v-show="IsShowEmail">
                    <div class="form-group">
                      <label>
                        {{ emailDisplayLabel }}
                        <span
                          class="required"
                          style="color: red"
                          v-show="IsEmailMandatory"
                          >*</span
                        >
                      </label>
                      <input
                        type="email"
                        class="form-control"
                        id="txtEmail"
                        @blur="validateEmailType()"
                      />
                      <!-- @blur="checkEmail()" -->
                    </div>
                  </div>
                  <div class="col-md-6" v-show="IsShowCompany">
                    <div class="form-group">
                      <label>
                        {{ companyDisplayLabel }}
                        <span
                          class="required"
                          style="color: red"
                          v-show="IsCompanyMandatory"
                          >*</span
                        >
                      </label>
                      <input
                        type="text"
                        class="form-control"
                        id="txtCompanyName"
                      />
                    </div>
                  </div>
                  <div class="col-md-6" v-show="IsShowTitle">
                    <div class="form-group">
                      <label>
                        {{ TitleDisplayLabel }}
                        <span
                          class="required"
                          style="color: red"
                          v-show="IsTitleMandatory"
                          >*</span
                        >
                      </label>
                      <input
                        type="text"
                        class="form-control"
                        id="txtDesignation"
                      />
                    </div>
                  </div>
                  <div class="col-md-6" v-show="IsShowMobile">
                    <div class="form-group">
                      <label>
                        {{ mobileDisplayLabel }}
                        <span
                          class="required"
                          style="color: red"
                          v-show="IsMobileMandatory"
                          >*</span
                        >
                      </label>
                      <input
                        v-if="!showMobileCountryCode"
                        type="number"
                        class="form-control"
                        id="txtMobilenumber"
                        min="0"
                        @keypress="restrictChars($event)"
                      />
                      <VuePhoneNumberInput
                        v-else
                        id="txtMobilenumber"
                        v-model="MobilenumberWithCountryCode"
                        :preferredCountries="['US', 'GB', 'SG', 'IN']"
                        @update="showPayload"
                        :default-country-code="CountryCode"
                      />
                      <!-- @blur="checkMobileLength()"-->
                    </div>
                  </div>
                  <div class="col-md-6" v-show="IsShowTags">
                    <div class="multiselect form-group">
                      <label>
                        {{ tagsDisplayLabel }}
                        <span
                          class="required"
                          style="color: red"
                          v-show="IsTagsMandatory"
                          >*</span
                        >
                      </label>
                      <div
                        class="selectBox clsspecialization"
                        @click="showCheckboxes"
                      >
                        <select
                          style="
                            height: 46px;
                            border: 1px solid #c0c5ca;
                            position: relative;
                          "
                        >
                          <!-- <option>Select an option</option> -->
                        </select>
                        <div id="dvspecialization" class="overSelect">
                          Select One
                        </div>
                      </div>
                      <div
                        id="checkboxes"
                        style="z-index: 9999; background: #fff; padding: 15px"
                        @click="HideShowcheckboxSelect"
                      >
                        <label for="one">
                          <input
                            type="checkbox"
                            name="specialization"
                            id="one"
                            value="FIT"
                            style="margin-right: 10px"
                            @click="calc"
                          />FIT
                        </label>
                        <label for="two">
                          <input
                            type="checkbox"
                            name="specialization"
                            id="two"
                            value="MICE/ Corporate Travel"
                            style="margin-right: 10px"
                            @click="calc"
                          />MICE/ Corporate Travel
                        </label>
                        <label for="three">
                          <input
                            type="checkbox"
                            name="specialization"
                            id="three"
                            value="Airlines"
                            style="margin-right: 10px"
                            @click="calc"
                          />Airlines
                        </label>
                        <label for="three">
                          <input
                            type="checkbox"
                            name="specialization"
                            id="three"
                            value="Weddings & Honeymoon"
                            style="margin-right: 10px"
                            @click="calc"
                          />Weddings & Honeymoon
                        </label>
                        <label for="three">
                          <input
                            type="checkbox"
                            name="specialization"
                            id="three"
                            value="Group Tours"
                            style="margin-right: 10px"
                            @click="calc"
                          />Group Tours
                        </label>
                        <label for="three">
                          <input
                            type="checkbox"
                            name="specialization"
                            id="three"
                            value="Cruises"
                            style="margin-right: 10px"
                            @click="calc"
                          />Cruises
                        </label>

                        <label for="three">
                          <input
                            type="checkbox"
                            name="specialization"
                            id="three"
                            value="Medical Tourism"
                            style="margin-right: 10px"
                            @click="calc"
                          />Medical Tourism
                        </label>
                      </div>
                    </div>
                  </div>
                  <div v-show="IsShowRegFormType" class="col-md-12">
                    <div class="form-group">
                      <label>{{ RegTypeDisplayLabel }}</label>
                      <span class="required" style="color: red">*</span>
                      <select
                        id="dropRegType"
                        class="form-control"
                        name="RegistrationType"
                        style="
                          height: 46px;
                          border: 1px solid #c0c5ca;
                          position: relative;
                        "
                        @change="setPopupPrice($event)"
                      ></select>
                    </div>
                  </div>

                  <!-- <div class="col-md-6">
                    <div class="form-group">
                      <label>Test dropdown</label>
                      <select id="cars" name="cars" class="form-control">
                        <option value="volvo">Volvo</option>
                        <option value="saab">Saab</option>
                        <option value="fiat">Fiat</option>
                        <option value="audi">Audi</option>
                      </select>
                    </div>
                  </div> -->

                  <!-- <div class="col-md-12">
<hr />
</div>-->

                  <div class="col-md-12" v-show="IsShowMailingAddress">
                    <div class="form-group">
                      <label>
                        {{ MailingAddressLabel }}
                        <span
                          class="required"
                          style="color: red"
                          v-show="IsMailingAddressMandatory"
                          >*</span
                        >
                      </label>
                      <input
                        required
                        type="text"
                        class="form-control"
                        id="txtMailingAddress"
                      />
                    </div>
                  </div>
                  <div v-show="IsShowCountryList" class="col-md-12">
                    <div class="form-group">
                      <label
                        >{{ CountryDisplayLabel }}
                        <span
                          class="required"
                          style="color: red"
                          v-show="IsCountryMandatory"
                          >*</span
                        ></label
                      >
                      <select
                        id="dropCountry"
                        name="CountryList"
                        class="form-control"
                        v-model="CountryName"
                        @change="GetStates($event)"
                      ></select>
                    </div>
                  </div>
                  <div v-show="IsShowStateList" class="col-md-12">
                    <div class="form-group">
                      <label>{{ StateDisplayLabel }}</label>
                      <span
                        class="required"
                        style="color: red"
                        v-show="IsStateMandatory"
                        >*</span
                      >
                      <select
                        id="dropState"
                        name="StateList"
                        class="form-control"
                      ></select>
                    </div>
                  </div>
                  <div v-show="IsShowOtherStateTextBox" class="col-md-12">
                    <div class="form-group">
                      <label id="OtherStateLabel"
                        >{{ OtherStateDisplayLabel }}
                        <span
                          class="required"
                          style="color: red"
                          v-show="IsStateMandatory"
                          >*</span
                        ></label
                      >

                      <input
                        required
                        type="text"
                        class="form-control"
                        id="txtOtherState"
                      />
                    </div>
                  </div>
                  <div class="col-md-12" v-show="IsShowCity">
                    <div class="form-group">
                      <label>
                        {{ CityDisplayLabel }}
                        <span
                          class="required"
                          style="color: red"
                          v-show="IsCityMandatory"
                          >*</span
                        >
                      </label>
                      <input
                        required
                        type="text"
                        class="form-control"
                        id="txt101"
                      />
                    </div>
                  </div>

                  <div class="col-md-12" v-show="IsShowZip">
                    <div class="form-group">
                      <label>
                        {{ ZipDisplayLabel }}
                        <span
                          class="required"
                          style="color: red"
                          v-show="IsZipMandatory"
                          >*</span
                        >
                      </label>
                      <input
                        required
                        type="text"
                        class="form-control"
                        id="txt100"
                      />
                    </div>
                  </div>
                  <!-- Extra form start-->
                  <div v-show="IsShowLongForm" class="col-md-12">
                    <vue-form-generator
                      :schema="schema"
                      :model="model"
                      :options="formOptions"
                    ></vue-form-generator>
                  </div>
                  <div class="col-md-12 button-area">
                    <div
                      v-if="HTMLbody.length > 0"
                      id="text_59"
                      v-html="HTMLbody"
                      class="form-html"
                      data-component="text"
                    ></div>
                    <label
                      v-if="HTMLbody.length > 0"
                      for="chkTermsAndConditions"
                    >
                      <input
                        type="checkbox"
                        name="TermsAndConditions"
                        id="chkTermsAndConditions"
                        value="I accept "
                        :checked="RequirePresignupAcceptance"
                        style="margin-right: 10px"
                      />
                      <span v-html="AcceptanceDisplayText"></span>
                      <span
                        class="required"
                        style="color: red"
                        v-show="RequirePresignupAcceptance"
                        >*</span
                      >
                    </label>
                    <br v-if="OptInOne.length > 0" />
                    <label v-if="OptInOne.length > 0" for="chkOptInONE">
                      <input
                        type="checkbox"
                        name="OptInONECheckBox"
                        id="chkOptInONE"
                        value="I accept "
                        style="margin-right: 10px"
                        :checked="OptInOneIsRequired"
                      />
                      <span v-html="OptInOne"></span>
                      <span
                        class="required"
                        style="color: red"
                        v-show="OptInOneIsRequired"
                      >
                        *</span
                      >
                    </label>
                    <br v-if="OptInTwo.length > 0" />
                    <label v-if="OptInTwo.length > 0" for="chkOptInTwo">
                      <input
                        type="checkbox"
                        name="OptInTwoCheckBox"
                        id="chkOptInTwo"
                        value="I accept "
                        style="margin-right: 10px"
                        :checked="OptInTwoIsRequired"
                      />
                      <span v-html="OptInTwo"></span>
                      <span
                        class="required"
                        style="color: red"
                        v-show="OptInTwoIsRequired"
                      >
                        *</span
                      >
                    </label>
                    <div class="clsButtonclass-new flex-wrap">
                      <button
                        type="button"
                        class="btn btn-defult-cancle text-uppercase mx-md-1"
                        @click.prevent="clearform()"
                        tabindex="-1"
                      >
                        Cancel
                      </button>
                      <button
                        id="btnRegister"
                        type="submit"
                        class="btn reg-button text-uppercase mx-md-1"
                        @click.prevent="SaveUserRegistration()"
                        style="background-color: rgb(20, 200, 41)"
                      >
                        {{ SubmitButtonText }}
                      </button>
                      <!-- <button
class="reg-button text-uppercase"
data-toggle="modal"
data-target="#payment-popup"
>popup</button>-->
                    </div>
                    <!-- <p class="term-amd-c pt-3 clscheckbox" style="font-size: 12px;">
By registering in , I Agree the
<a
href="https://e2m.live/privacy-policy"
style="color: #ef222b;"
>Privacy Policy</a> and
<a
href="https://e2m.live/terms-of-use"
style="color: #ef222b;"
>Terms of Conditions</a>
</p>-->
                  </div>
                  <!-- extra form ends -->
                </div>
              </form>
            </div>
          </div>
          <!--------------->
          <!------------>
        </div>
      </div>
    </section>
    <div
      id="divLoading"
      style="
        margin: 0px;
        padding: 0px;
        position: fixed;
        right: 0px;
        top: 0px;
        width: 100%;
        height: 100%;
        z-index: 30001;
        opacity: 1;
        transform: scale(2);
        display: none;
      "
    >
      <!-- <p style="position: fixed; top: 45%; left: 45%;"> -->
      <div class="loader">
        <svg
          width="65px"
          height="65px"
          viewBox="0 0 66 66"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g>
            <animateTransform
              attributeName="transform"
              type="rotate"
              values="0 33 33;270 33 33"
              begin="0s"
              dur="1.4s"
              fill="freeze"
              repeatCount="indefinite"
            />
            <circle
              fill="none"
              stroke-width="6"
              stroke-linecap="round"
              cx="33"
              cy="33"
              r="30"
              stroke-dasharray="187"
              stroke-dashoffset="610"
            >
              <animate
                attributeName="stroke"
                values="#4285F4;#DE3E35;#F7C223;#1B9A59;#4285F4"
                begin="0s"
                dur="5.6s"
                fill="freeze"
                repeatCount="indefinite"
              />
              <animateTransform
                attributeName="transform"
                type="rotate"
                values="0 33 33;135 33 33;450 33 33"
                begin="0s"
                dur="1.4s"
                fill="freeze"
                repeatCount="indefinite"
              />
              <animate
                attributeName="stroke-dashoffset"
                values="187;46.75;187"
                begin="0s"
                dur="1.4s"
                fill="freeze"
                repeatCount="indefinite"
              />
            </circle>
          </g>
        </svg>
      </div>
      <!-- </p> -->
    </div>
    <!-- Success Modal -->
    <div class="modal fade all-modal" id="success-modal">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-body p-0">
            <button
              type="button"
              style="margin-top: -10"
              data-dismiss="modal"
              aria-label="Close"
              class="close"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18.03"
                height="18.031"
                viewBox="0 0 18.03 18.031"
              >
                <path
                  id="close.svg"
                  fill="#242432"
                  d="M1422.25,525.005l7.51,7.508a0.885,0.885,0,0,1,0,1.243,0.876,0.876,0,0,1-1.24,0l-7.51-7.508-7.51,7.508a0.876,0.876,0,0,1-1.24,0,0.867,0.867,0,0,1,0-1.243l7.51-7.508-7.51-7.507a0.878,0.878,0,0,1,1.24-1.243l7.51,7.508,7.51-7.508a0.874,0.874,0,0,1,1.24,0,0.885,0.885,0,0,1,0,1.243Z"
                  transform="translate(-1412 -516)"
                />
              </svg>
            </button>
            <span
              class="
                success-icon
                d-flex
                justify-content-center
                align-items-center
              "
            >
              <img src="../assets/Images/icons/tick.svg" />
            </span>
            <p>
              <strong>Registration Completed Successfully!</strong>
            </p>
            <p>You will receive a confirmation email with your login link.</p>
            <p>
              <strong>Please save your confirmation email.</strong>
            </p>
            <p>
              If you do not receive the email, please check your
              <span style="color: #ff0000">spam folder</span> or contact event
              planner.
            </p>
            <p>
              <span
                data-dismiss="modal"
                class="btn-pink sussecc-btn"
                @click="GreatClicked"
                >Great!</span
              >
            </p>
          </div>
        </div>
      </div>
    </div>
    <!-- Success Modal Ends-->
    <!-- Othe msg  Modal -->
    <div class="modal fade all-modal" id="Othermsg-modal">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-body p-0">
            <button
              type="button"
              style="margin-top: -10"
              data-dismiss="modal"
              aria-label="Close"
              class="close"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18.03"
                height="18.031"
                viewBox="0 0 18.03 18.031"
              >
                <path
                  id="close.svg"
                  fill="#242432"
                  d="M1422.25,525.005l7.51,7.508a0.885,0.885,0,0,1,0,1.243,0.876,0.876,0,0,1-1.24,0l-7.51-7.508-7.51,7.508a0.876,0.876,0,0,1-1.24,0,0.867,0.867,0,0,1,0-1.243l7.51-7.508-7.51-7.507a0.878,0.878,0,0,1,1.24-1.243l7.51,7.508,7.51-7.508a0.874,0.874,0,0,1,1.24,0,0.885,0.885,0,0,1,0,1.243Z"
                  transform="translate(-1412 -516)"
                />
              </svg>
            </button>
            <div id="dvOtherMsg" class="classOtheMsg">
              This email is already registered, please sign-up with a different
              email.
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Othe msg  Modal Ends-->
    <!---Payment modal start---->
    <!-- Modal -->
    <div
      class="modal fade"
      id="payment-popup"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content payment-popup">
          <!---header start ---->
          <div class="modal-header">
            <!--<button type="button" class="close" data-dismiss="modal" aria-label="Close">
<svg xmlns="http://www.w3.org/2000/svg" width="18.03" height="18.031" viewBox="0 0 18.03 18.031"><path id="close.svg" fill="#242432" d="M1422.25,525.005l7.51,7.508a0.885,0.885,0,0,1,0,1.243,0.876,0.876,0,0,1-1.24,0l-7.51-7.508-7.51,7.508a0.876,0.876,0,0,1-1.24,0,0.867,0.867,0,0,1,0-1.243l7.51-7.508-7.51-7.507a0.878,0.878,0,0,1,1.24-1.243l7.51,7.508,7.51-7.508a0.874,0.874,0,0,1,1.24,0,0.885,0.885,0,0,1,0,1.243Z" transform="translate(-1412 -516)"></path></svg>
</button>-->

            <div
              class="
                d-flex
                justify-content-between
                align-items-center
                top-p-header
              "
            >
              <div class="left-side">
                <p>Paying To</p>
                <!-- <h3>{{ clientName }}</h3> -->
                <h3>{{ Payingto }}</h3>
              </div>
              <div class="right-side">
                <img id="imgHostLogo" v-bind:src="hostLogo" alt="e2m" />
                <!-- <img src="../assets/Images/neche.png" /> -->
              </div>
            </div>
          </div>
          <!---header end ---->
          <div class="text-center alert alert-success mt-3" style="">
            <span style="font-weight: bold">Up Next!</span><br />
            <span> Registration done, please proceed to Pay Now </span>
          </div>
          <div class="modal-body pt-4">
            <!-- <div class="p-plan-box">
<span class="p-plan-name">{{productName}}</span>
<span>{{ItemPrice}}</span>
</div>-->
            <!-- <div class="p-plan-box">
<span class="p-plan-name">2 X Gold</span>
<span>&#36;1,600</span>
</div>-->

            <div class="p-plan-box total-p-price">
              <span
                id="spntotalPrice"
                class="p-plan-name"
                style="width: 70%; padding-right: 15px; word-break: break-word"
                >{{ productName }}</span
              >
              <span>{{ ItemPrice }}</span>
            </div>

            <div class="modal-footer text-center mt-4 paymentFooter">
              <!-- <div v-if="PaymentSource.toLowerCase() == 'paypal'">
                <PayPal
                  :amount="ItemPrice.replace('$', '')"
                  :currency="PaypalCurrency"
                  :client="PPcredentials"
                  :env="PaypalEnv"
                  v-on:payment-completed="PPPcomplete"
                  v-on:payment-cancelled="PPPcanceled"
                  :invoice-number="`${customerEmail}#OA_UAT#${evntId}#${clientID}`"
                >
                </PayPal>
              </div> -->
              <div >
                <stripe-checkout
                  ref="checkoutRef"
                  :pk="publishableKey"
                  :lineItems="lineItems"
                  :successUrl="successUrl"
                  :cancelUrl="cancelUrl"
                  :mode="mode"
                  :clientReferenceId="clientReferenceId"
                  :customerEmail="customerEmail"
                >
                  <template slot="checkout-button" style="width: 100%">
                    <button
                      id="btnStripePayment"
                      @click.prevent="checkout()"
                      class="reg-button text-uppercase mb-2"
                    >
                      Proceed To Pay<i class="fa fa-external-link"></i>
                    </button> </template
                ></stripe-checkout>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
.payment-popup .modal-body .p-plan-box.total-p-price {
  border-top: 0px;
}
.paymentFooter div {
  width: 100%;
}
#dvreg .field-wrap .combobox .info {
  position: relative;
  color: #fff;
}
#dvreg .field-wrap .combobox .info:before {
  content: "" !important;
  color: #000;
  z-index: 1;
}
#dvreg .info {
  background-color: #fff !important;
  border-color: #fff !important;
  color: #000 !important;
}
/* .vue-form-generator .form-group:nth-child(4) span {
font-size: 22px;
font-weight: bold;
} */
.vue-form-generator .form-group:nth-child(13) span {
  /*font-size: 22px;*/
}
.vue-form-generator .form-group:nth-child(14) {
  float: left;
  width: 33.33% !important;
  padding: 0 5px 0 0 !important;
}
.vue-form-generator .form-group:nth-child(15) {
  float: left;
  width: 33.33% !important;
  padding: 0 5px !important;
}

.vue-form-generator .form-group:nth-child(16) {
  float: left;
  width: 33.33% !important;
  padding: 0 0 0 5px !important;
}

.vue-form-generator .form-group:nth-child(17) {
  float: left;
  width: 33.33% !important;
  padding: 0 5px 0 0 !important;
}
.vue-form-generator .form-group:nth-child(18) {
  float: left;
  width: 33.33% !important;
  padding: 0 5px !important;
}

.vue-form-generator .form-group:nth-child(19) {
  float: left;
  width: 33.33% !important;
  padding: 0 0 0 5px !important;
}

.vue-form-generator .form-group:nth-child(20) {
  float: left;
  width: 33.33% !important;
  padding: 0 5px 0 0 !important;
}
.vue-form-generator .form-group:nth-child(21) {
  float: left;
  width: 33.33% !important;
  padding: 0 5px !important;
}

.vue-form-generator .form-group:nth-child(22) {
  float: left;
  width: 33.33% !important;
  padding: 0 0 0 5px !important;
}
.clsButtonclass {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.clsButtonclass-new {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.clsButtonclass-new .btn {
  /*margin-left: 15px;*/
}
.page-effect .col-md-6 .form-group {
  margin-bottom: 0px;
}
.reg-right-hld .reg-button {
  width: auto !important;
}
/* span[text="Personal Details"] {
color: red;
} */
/* Multi select drop down style */
.multiselect {
  width: 200px;
}

.selectBox {
  position: relative;
}

.selectBox select {
  width: 100%;
  font-weight: bold;
}

.overSelect {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
}

#checkboxes {
  display: none;
  border: 1px #dadada solid;
}

#checkboxes label {
  display: block;
}

#checkboxes label:hover {
  background-color: #1e90ff;
}
.clsspecialization select:focus {
  border: none;
  box-shadow: inherit;
}

.top-right-login.hdr-btn {
  padding: 8px 0 !important;
}
/* Multi select drop down style ends */
@media only screen and (max-width: 768px) {
  .clsButtonclass {
    flex-direction: column;
  }
  .clsButtonclass button {
    width: 100% !important;
    margin-top: 12px;
    margin-left: 0 !important;
  }
  .vue-form-generator .form-group:nth-child(14),
  .vue-form-generator .form-group:nth-child(15),
  .vue-form-generator .form-group:nth-child(16),
  .vue-form-generator .form-group:nth-child(17),
  .vue-form-generator .form-group:nth-child(18),
  .vue-form-generator .form-group:nth-child(19),
  .vue-form-generator .form-group:nth-child(20),
  .vue-form-generator .form-group:nth-child(21),
  .vue-form-generator .form-group:nth-child(22) {
    width: 100% !important;
    padding: 0 0px 0 0 !important;
  }
  .top-login-wrapper .top-right-login a.event-List {
    margin-left: 0 !important;
  }
  .top-login-wrapper .top-right-login.hdr-btn {
    padding-bottom: 0 !important;
  }
}

.overSelect {
  top: 10px;
  left: 15px;
}
#checkboxes {
  position: absolute;
  border: 0;
  box-shadow: 0px 9px 12px 1px rgba(0, 0, 0, 0.14);
}
/*.register-page-wrapper .btn-defult-cancle {
  flex: 1 1 auto;
}
.register-page-wrapper .reg-button {
  flex: 1 1 auto;
}*/

@media (max-width: 768px) {
  .register-page-wrapper .container {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
}

@media only screen and (max-width: 667px) {
  .register-page-wrapper .btn-defult-cancle {
    flex: 1 1 100%;
    margin-bottom: 10px;
  }
  .register-page-wrapper .reg-button {
    flex: 1 1 100%;
  }
}
</style>
<script>
import Vue from "vue";
import jQuery from "jquery";
import APIs from "@/components/APIInit";
let $ = jQuery;
import db from "../components/firebaseInit";
import router from "../router";
import { bus } from "@/main";
var self;
// import Vue from "vue";
// import VueMoment from "vue-moment";
import moment from "moment-timezone";
import firebase from "firebase";
import axios from "axios";
import VueFormGenerator from "vue-form-generator";
import "vue-form-generator/dist/vfg.css";
// import store from "../store";
//import store from "../store";
import { StripeCheckout } from "vue-stripe-checkout";
//"vue-paypal-checkout": "^3.2.0",
//import PayPal from "vue-paypal-checkout";
//import common from "@/common";
import VuePhoneNumberInput from "vue-phone-number-input";
import "vue-phone-number-input/dist/vue-phone-number-input.css";
import Countdown from "vuejs-countdown";
Vue.use(VueFormGenerator);

const storageRef = firebase;
let DynamicInputs = {};
var routeReferer = null;
var refererPath = null;
export default {
  components: {
    StripeCheckout,
    //PayPal,
    VuePhoneNumberInput,
    Countdown,
  },
  props: {
    regEventId: {
      type: String,
      default: "",
    },
  },
  metaInfo() {
    return {
      title: this.EventsData ? this.EventsData[0].EventName : "",
      meta: [
        {
          property: "og:title",
          content: this.EventsData ? this.EventsData[0].EventName : "",
        },
        {
          property: "og:url",
          content: this.customDomain ? this.customDomain : "",
        },
        { property: "og:type", content: "website" },
        { property: "og:description", content: "website" },
        { property: "og:site_name", content: "Epiloge" },
        {
          property: "og:description",
          content: this.EventsData ? this.EventsData[0].EventName : "",
        },
        {
          property: "og:image",
          content: this.EventsData ? this.EventsData[0].EventLogo : "",
        },
        {
          property: "twitter:card",
          content: this.EventsData ? this.EventsData[0].EventName : "",
        },
        {
          property: "twitter:title",
          content: this.EventsData ? this.EventsData[0].EventName : "",
        },
        {
          property: "twitter:description",
          content: this.EventsData ? this.EventsData[0].EventName : "",
        },
        {
          property: "twitter:url",
          content: this.customDomain ? this.customDomain : "",
        },
        {
          property: "twitter:description",
          content: this.EventsData ? this.EventsData[0].EventName : "",
        },
        {
          property: "twitter:image",
          content: this.EventsData ? this.EventsData[0].EventLogo : "",
        },
      ],
    };
  },
  data() {
    return {
      customDomain: "",
      AllowRegistration: true,
      postToCRM: false,
      hostLogo: "",
      ItemPrice: "$0",
      productName: "",
      RegTicketType: "",
      /******************** PAYPAL ******************************************************/
      PPPitems: [
        {
          name: "",
          description: "",
          quantity: "1",
          price: "",
          currency: "USD",
          customerEmail: "",
          instanceId: "OA_UAT",
          clientId: "",
          evntId: "",
          eventName: "",
          clientName: "",
          eventcollectionname: "",
        },
      ],
      PaypalCurrency: "USD",
      PaypalEnv: "sandbox",
      PPcredentials: {
        sandbox:
          "AWdnWJe82bnGuYfCp6ghesAJEMG4l2oVRsrNWQlHFLJjgieTr-Cm_s-4tnJdoRa6Hp6FZlelrWPycKCC", //E2m client id
        production: "",
      },
      /***********************STRIPE**************************************************** */
      Payingto: "E2M Live",
      PaymentStatus: "PENDING",
      PaymentSource: "STRIPE",
      enablePaymentPop: true,

      loading: false,
      publishableKey:
        "pk_test_51HSEkxJy5CUjqeXa6XpfGrMFYzhhHq2wXnskSEBb8fqdmmjKnE8ZcB6i0VueYE9Y5SLObgqIiSdBxCvARZDRFCfD000UNXug3y", // live key:- "pk_live_yR0upxE0W5Xzq3lA0td0yxQ7",
      lineItems: [
        {
          price: "",
          quantity: 1,
        },
      ],
      mode: "payment",
      successUrl: "https://" + location.host + "/regpaymentSuccess",
      cancelUrl: "https://" + location.host + "/regpaymentFailure",
      customerEmail: "",
      clientReferenceId: "",
      /*************************************************************************** */

      ShowEventListLink: true,
      AcceptanceDisplayText: "I Accept",
      AcceptanceValidationDisplayLabel: "Please accept terms and condiotions.",
      FormType: "Free",
      SubmitButtonText: "Complete Registration",
      //Pre signup------------------------------------------------
      HTMLbody: "",
      RequirePresignupAcceptance: false,
      OptInOne: "",
      OptInOneIsRequired: false,
      OptInTwo: "",
      OptInTwoIsRequired: false,
      //default fields---------------------------------------------
      IsShowSalutation: false,
      IsShowfName: true,
      IsShowlName: true,
      IsShowProfilePicture: false,
      IsShowEmail: true,
      IsShowCompany: true,
      IsShowTitle: false, //designation
      IsShowMobile: false,
      IsShowTags: false,
      IsShowRegFormType: false,
      IsShowCountryList: false,
      IsShowZip: false,
      IsShowStateList: false,
      IsEnabledState: true, //to decide if a client chooses to show STATE feature or NOT
      IsShowOtherStateTextBox: false,
      IsShowCity: false,
      IsShowMailingAddress: false,
      //========================================

      IsfNameMandatory: true,
      IslNameMandatory: true,
      IsProfilePictureMandatory: false,
      IsEmailMandatory: true,
      IsCompanyMandatory: false,
      IsTitleMandatory: false,
      IsMobileMandatory: false,
      IsTagsMandatory: false,
      IsCountryMandatory: false,
      IsZipMandatory: false,
      IsStateMandatory: false,
      IsCityMandatory: false,
      IsMailingAddressMandatory: false,
      //===Display Label  ================================
      salutationDisplayLabel: "Salutation",
      firstNameDisplayLabel: "First Name",
      lastNameDisplayLabel: "Last Name",
      ProfilePictureDisplayLabel: "Profile Picture",
      emailDisplayLabel: "Email Address",
      companyDisplayLabel: "Company(Optional)",
      TitleDisplayLabel: "Title",
      mobileDisplayLabel: "Mobile Number",
      tagsDisplayLabel: "Specialization (choose multiple, if applicable)",
      RegTypeDisplayLabel: "TicketCurr:",
      CountryDisplayLabel: "Countries",
      ZipDisplayLabel: "Zip",
      StateDisplayLabel: "State",
      OtherStateDisplayLabel: "State",
      CityDisplayLabel: "City",
      MailingAddressLabel: "Mailing Address",
      //-----------------------------------------------------------

      BannerURL: "",
      expanded: false,
      btntextColor: "black",
      btnBackColor: "#ef222b",
      //-------Form generator []-----------------------------------------
      uploadedProfilePicturePath: "",
      getDynamincfieldsFromDB: false,
      model: DynamicInputs,

      schema: {
        fields: [],
      },

      formOptions: {
        validateAfterLoad: true,
        validateAfterChanged: true,
        validateBeforeSubmit: true,
      },
      fields: [],
      fieldData: [],
      FormId: "ARROW",
      FormJson: "",
      shortforCSSClass: "",
      clientID: "",
      visitor: false,
      redirectToLogin: false,
      email: "",
      evntId: "",
      eventName: "",
      clientName: "",
      hostName: "",
      eventcollectionname: "",
      IsShowLongForm: true,
      EventsData: [],
      reg: /^(([^<>()/[\]//.,;:\s@"]+(\.[^<>()/[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
      date: moment.tz("2020-06-26 00:00", "Asia/Calcutta"),
      mobileBanner: "",
      desktopBanner: "",
      showMobileCountryCode: false,
      MobilenumberWithCountryCode: "",
      CountryCode: "",
      CountryName: "",
      IsValidMobilenumber: false,
      publicEventCollection: "",
    };
  },
  watch: {
    file: function (val) {
      alert(val);
    },
    redirectToLogin(val) {
      if (val) {
        self.autoLoginAfterReg();
      }
    },
  },
  created() {
    self = this;
    self.initScreen();
    $(window).resize(function () {
      self.initScreen();
    });
  },
  beforeRouteEnter(to, from, next) {
    routeReferer = from.name;
    refererPath = from.fullPath;
    console.log(routeReferer);
    //alert(refererPath);
    next(true);
  },
  async mounted() {
    $("#topmenu").hide();
    $("#leftmenu").hide();

    if (self.$store.state.publicEventCollection) {
      self.publicEventCollection = self.$store.state.publicEventCollection;
    }
    self.showLoader();
    self.selectCountry();
    self.EventsData = [];
    self.evntId = self.$route.params.e;
    var visitor = self.$route.params.visitor;
    if (visitor == "visitor") {
      self.visitor = true;
    }
    if (self.regEventId) {
      self.evntId = self.regEventId;
      self.visitor = true;
    }
    //alert(self.visitor);
    console.log(self.evntId);
    const HOSTURL = process.env.VUE_APP_LOCALHOST_URL_EDU;
    if (location.host.toLowerCase().indexOf("localhost") >= 0) {
      self.hostName = HOSTURL ? HOSTURL : self.LocalhostDomain();
    } else {
      self.hostName = HOSTURL ? HOSTURL : location.host;
    }
    var path;
    console.log(self.hostName);
    if (self.hostName.toLowerCase().indexOf("uat") > -1) {
      path = "https://resources.e2m.live/uate2monair.appspot.com/";
    } else {
      path = APIs.googleSoragePath;
    }
    axios
      .get(
        path + "OA_UAT%2FClients%2FHosts%2F" + this.hostName + ".json?alt=media"
      )
      .then(async (res) => {
        if (res && res.data && !self.visitor) {
          bus.$emit("EnableHelpChat", "Event", res.data.ClientId);
        }
        self.clientID = res.data.ClientId;
        self.clientName = res.data.ClientName;
        self.eventcollectionname = "OA_UAT_" + self.clientID + self.evntId;
        self.customDomain = res.data.CustomDomain;

        axios
          .get(
            APIs.EventBrandingJsonData +
              "?iid=OA_UAT" +
              "&cid=" +
              self.clientID +
              "&eid=" +
              self.evntId
          )
          .then(async (res) => {
            this.item = res.data.result;
            self.postToCRM =
              res.data.result.postToCRM == undefined
                ? false
                : res.data.result.postToCRM;
            if (res.data.result.EventInfo && res.data.result.EventInfo.EventBanner) {
              self.desktopBanner =
                res.data.result.EventInfo.EventBanner;                
            }
            else if (res.data.result.ClientInfo && res.data.result.ClientInfo.EventListAssets.banner2048x88) {
              self.desktopBanner =
                res.data.result.ClientInfo.EventListAssets.banner2048x88;                
            }

            if (res.data.result.EventInfo && res.data.result.EventInfo.EventBannerMobile) {
              self.mobileBanner =
                res.data.result.EventInfo.EventBannerMobile;
            }
            else if (res.data.result.ClientInfo && res.data.result.ClientInfo.EventListAssets.banner750x103) {
              self.mobileBanner =
                res.data.result.ClientInfo.EventListAssets.banner750x103;
            }
            self.initScreen();

            var dateFormat = require("dateformat");

            console.log(res.data.result.EventInfo.EventFullName);
            var obj = new Object();

            obj.eventId = self.evntId;
            obj.EventName = res.data.result.EventInfo.EventFullName;
            self.eventName = res.data.result.EventInfo.EventFullName;
            self.AllowRegistration =
              res.data.result.EventInfo.AllowRegistration;
            //-----------------------------------------------------------------------
            if (self.AllowRegistration == false) {
              var str = res.data.result.EventInfo.EventFullName.replace(
                / /g,
                "_"
              );
              var str2 = str.replace(/%20/g, " ");

              router.push({
                path: "/event/" + self.evntId + "/" + str2,
              });
            }
            //-------------------------------------------------------------------
            //----------------------------------------MetaTag-------------------------------------------------------------------------------------------------
            document.title =
              res.data.result.EventInfo.EventFullName + " - " + self.clientName;

            var link = document.createElement("meta");
            link.setAttribute("property", "description");
            link.content = res.data.result.EventInfo.Description;
            document.getElementsByTagName("head")[0].appendChild(link);

            $("head").append(
              '<meta name="description" content="' +
                res.data.result.EventInfo.Description +
                '">'
            );

            $("head").append(
              '<meta property="og:title" content="' +
                res.data.result.EventInfo.EventFullName +
                '">'
            );

            $("head").append(
              '<meta property="og:description" content="' +
                res.data.result.EventInfo.Description +
                '">'
            );

            $("head").append(
              '<meta property="og:image" content="' + self.BannerURL + '">'
            );

            $("head").append(
              '<meta property="og:url" content="' + self.hostName + '">'
            );
            //-------------------------------------------------------------------------------------------------------------
            obj.EventTimezoneZ = moment.tz.guess();
            obj.EventLogo = res.data.result.EventInfo.EventLogo;
            obj.Description = res.data.result.EventInfo.Description;

            obj.EventStartDate = dateFormat(
              res.data.result.EventInfo.EventStartDate,
              "mmm dd, hh:MM TT"
            );

            obj.EventEndDate = dateFormat(
              res.data.result.EventInfo.EventEndDate,
              "mmm dd, hh:MM TT"
            );

            obj.EventStartDateZ = self.GetTimeByZone(
              res.data.result.EventInfo.EventStartDate,
              res.data.result.EventInfo.TimeZone
            );

            obj.EventStartDateZ = dateFormat(
              obj.EventStartDateZ,
              "mmm dd, hh:MM TT"
            );
            obj.EventEndDateZ = self.GetTimeByZone(
              res.data.result.EventInfo.EventEndDate,
              res.data.result.EventInfo.TimeZone
            );

            obj.EventEndDateZ = dateFormat(
              obj.EventEndDateZ,
              "mmm dd, hh:MM TT"
            );
            self.EventsData.push(obj);
            //------------------------------------------------------
            self.ClientName = res.data.result.HostInfo.Name;
            self.clientLogoUrl = res.data.result.HostInfo.Logo;
            self.clientProfile = res.data.result.HostInfo.Profile;

            self.getButtonBranding(self.hostName);
            if (!self.visitor) {
              self.getStaticFieldSettings();
              self.getTermsAndConditionsFields();

              if (self.getDynamicFields) {
                self.getDynamicFields();
              }
            }
          })
          .catch((error) => {
            console.error(
              "There was an error to read event branding: " + error
            );
          });
      })
      .catch((error) => {
        console.error("There was an error to read client branding: " + error);
      });

    self.hideLoader();
    var testElements = document.getElementsByClassName("info");
    console.log("info" + testElements);
  },
  methods: {
    selectCountry() {
      axios
        .get(
          "https://api.geoapify.com/v1/ipinfo?apiKey=37a6bcd1c1184615a858b3ad499aa89c"
        )
        .then(async (res) => {
          self.CountryName = res.data.country.name;
          self.CountryCode = res.data.country.iso_code;
        })
        .catch((error) => {
          console.error("There was an error to read client branding: " + error);
        });
    },
    showPayload(payload) {
      self.IsValidMobilenumber = payload.isValid;
      self.MobilenumberWithCountryCode = payload.formatInternational;
    },
    initScreen() {
      if (window.innerWidth > 768) {
        self.BannerURL = self.desktopBanner;
      } else {
        self.BannerURL = self.mobileBanner;
      }
    },
    GreatClicked(e) {
      if (self.visitor) {
        var timeout = 5000;
        if (e) {
          timeout = 1;
        }
        setTimeout(() => {
          self.redirectToLogin = true;
          self.showSnackbar("Loging in...", "success", "top");
        }, timeout);
      } else {
        location.reload();
      }
    },
    initVisitorRegForm(regEventId) {
      self.EventId = regEventId;
      self.visitor = true;
    },
    PPPcanceled: function (res) {
      console.log(res);
      $("#payment-popup").modal("hide");
      alert("Payment not done!");
    },
    PPPcomplete: function (res) {
      console.log(res);
      $("#payment-popup").modal("hide");
      alert("Payment Successfull.");
    },
    setPopupPrice: function () {
      var dropRegType = document.getElementById("dropRegType");
      var strRegtype =
        dropRegType.options[dropRegType.selectedIndex].getAttribute("datatag");
      console.log(strRegtype);
      if (strRegtype.includes(".0")) {
        self.ItemPrice = strRegtype;
      } else {
        self.ItemPrice = strRegtype + ".00";
      }

      self.productName = dropRegType.options[dropRegType.selectedIndex].text;
    },
    checkout() {
      debugger;
      console.log(self.publishableKey);
      console.log("successurl - " + self.successUrl);
      console.log("CancelUrl- " + self.succescancelUrlsUrl);

      var dropRegType = document.getElementById("dropRegType");
      var strRegtype = dropRegType.options[dropRegType.selectedIndex].value;
      if (strRegtype == "$0") {
        document.getElementById("dvOtherMsg").innerText =
          "Please select an option";
        $("#Othermsg-modal").modal("show");
        return false;
      } else {
        var spn = document.getElementById("spntotalPrice");
        spn.style.color = "red";

        document.getElementById("btnStripePayment").innerText =
          "Redirecting to stripe...";

        var key = {
          instanceId: "OA_UAT",
          clientId: self.clientID.toString(),
          eventId: parseInt(self.evntId.replace("E", "")),
        };
        console.log(JSON.stringify(key));
        self.clientReferenceId = JSON.stringify(key);
        var email = document.getElementById("txtEmail").value;
        self.customerEmail = email;
        self.lineItems[0].price = strRegtype;
        setTimeout(() => {
          this.$refs.checkoutRef.redirectToCheckout();
        }, 2000);
      }
    },
    getStaticFieldSettings: function () {
      debugger;
      var evntCol = "OA_UAT_" + self.clientID + self.evntId;
      const storage = firebase.storage();
      const storageRef = storage.ref();
      const objStaticFieldRef = storageRef.child(
        evntCol + "/Registration/DefaultRegFormSettings.JSON"
      );

      objStaticFieldRef.getDownloadURL().then((url) => {
        axios.get(url).then((response) => {
          self.shortforCSSClass = "";

          //--------------------------------------------------------------------------
          debugger;
          if (self.hostName.toLowerCase().indexOf("uat") > -1) {
            self.publishableKey = response.data.TestPublishableKey;
          } else {
            self.publishableKey = response.data.LivePublishableKey;
          }
          //------------------------Payingto--------------------------------
          self.Payingto =
            response.data.Payingto != undefined ? response.data.Payingto : "";
          self.hostLogo =
            response.data.PayingToLogo != undefined
              ? response.data.PayingToLogo
              : "";
          //--------------------------------------------------------------------------
          if (response.data.Mobile.IsShowMobile) {
            self.showMobileCountryCode = response.data.Mobile.IsShowMobile;
          }
          console.log(response.data.FormType);
          self.FormType = response.data.FormType;
          self.PaymentSource = response.data.PaymentSource
            ? response.data.PaymentSource
            : "STRIPE";
          self.PaypalEnv = response.data.PaypalEnv
            ? response.data.PaypalEnv
            : "sandbox";
          self.PaypalCurrency = response.data.PaypalCurrency
            ? response.data.PaypalCurrency
            : "USD";
          self.PPcredentials = response.data.PPcredentials
            ? response.data.PPcredentials
            : null;
          //------------------Salutation------------------------------------------------
          self.salutationDisplayLabel =
            response.data.Salutation.salutationDisplayLabel;
          self.IsShowSalutation = response.data.Salutation.IsShowSalutation;
          //------------------FirstName------------------------------------------------
          self.IsShowfName = response.data.FirstName.IsShowfName;
          self.IsfNameMandatory = response.data.FirstName.IsfNameMandatory;
          self.firstNameDisplayLabel =
            response.data.FirstName.firstNameDisplayLabel;
          //------------------LastName------------------------------------------------
          self.IsShowlName = response.data.LastName.IsShowlName;
          self.IslNameMandatory = response.data.LastName.IslNameMandatory;
          self.lastNameDisplayLabel =
            response.data.LastName.lastNameDisplayLabel;
          //--------------ProfilePicture----------------------------------------------------
          self.IsShowProfilePicture =
            response.data.ProfilePicture.IsShowProfilePicture;
          self.IsProfilePictureMandatory =
            response.data.ProfilePicture.IsProfilePictureMandatory;
          self.ProfilePictureDisplayLabel =
            response.data.ProfilePicture.ProfilePictureDisplayLabel;
          //----------------------Email--------------------------------------------------
          self.IsShowEmail = response.data.Email.IsShowEmail;
          self.IsEmailMandatory = response.data.Email.IsEmailMandatory;
          self.emailDisplayLabel = response.data.Email.emailDisplayLabel;
          //----------------------Company--------------------------------------------
          self.IsShowCompany = response.data.Company.IsShowCompany;
          self.IsCompanyMandatory = response.data.Company.IsCompanyMandatory;
          self.companyDisplayLabel = response.data.Company.companyDisplayLabel;
          //----------------------Title---------------------------------------------
          self.IsShowTitle = response.data.Title.IsShowTitle;
          self.IsTitleMandatory = response.data.Title.IsTitleMandatory;
          self.TitleDisplayLabel = response.data.Title.TitleDisplayLabel;
          //----------------------Mobile-------------------------------------------
          self.IsShowMobile = response.data.Mobile.IsShowMobile;
          self.IsMobileMandatory = response.data.Mobile.IsMobileMandatory;
          self.mobileDisplayLabel = response.data.Mobile.mobileDisplayLabel;
          //---------------------Tags------------------------------------------------
          self.IsShowTags = response.data.Tags.IsShowTags;
          self.IsTagsMandatory = response.data.Tags.IsTagsMandatory;
          self.tagsDisplayLabel = response.data.Tags.tagsDisplayLabel;
          //---------------------Registration Type------------------------------------------------
          self.IsShowRegFormType =
            response.data.RegistrationType.IsShowRegFormType;
          self.RegTypeDisplayLabel =
            response.data.RegistrationType.RegTypeDisplayLabel;
          if (self.IsShowRegFormType) {
            if (response.data.RegistrationType.RegTypes != undefined) {
              if (response.data.RegistrationType.RegTypes.length > 0) {
                var select = document.getElementById("dropRegType");
                for (
                  var i = response.data.RegistrationType.RegTypes.length - 1;
                  i >= 0;
                  i--
                ) {
                  var option = document.createElement("option");
                  option.text = response.data.RegistrationType.RegTypes[i].Name;
                  option.value =
                    response.data.RegistrationType.RegTypes[i].TicketPriceID;
                  option.setAttribute(
                    "datatag",
                    response.data.RegistrationType.RegTypes[i].TicketPrice
                  );
                  let datacolor = response.data.RegistrationType.RegTypes[i]
                    .ColorCode
                    ? response.data.RegistrationType.RegTypes[i].ColorCode
                    : "#ffffff00";
                  option.setAttribute("datacolor", datacolor);
                  select.add(option, 0);
                }
                $("select option:first-child").attr("selected", "selected");
              }
            }
          }

          //---------------------Country List------------------------------------------------
          debugger;
          self.IsShowCountryList = response.data.Country.IsShowCountryList;
          self.CountryDisplayLabel = response.data.Country.CountryDisplayLabel;

          self.IsCountryMandatory = response.data.Country.IsCountryMandatory;
          var cntryOption = "";
          if (response.data.Country.countryList.length > 0) {
            cntryOption = response.data.Country.countryList.split(",");
          }
          var selectCountry = document.getElementById("dropCountry");
          for (var j = cntryOption.length - 1; j >= 0; j--) {
            var optionCountry = document.createElement("option");
            optionCountry.text = optionCountry.value = cntryOption[j];
            selectCountry.add(optionCountry, 0);
          }
          $("select option:first-child").attr("selected", "selected");
          //---------------------Submit Button Settings------------------------------------------------
          self.SubmitButtonText = response.data.SubmitButtonDisplayLabel;
          //-------------------------------------------------------------------------------------
          //------------------------------------------------------------------
          if (response.data.LandingPageShowEventListLink != undefined) {
            self.ShowEventListLink = response.data.LandingPageShowEventListLink;
          }
          //---------------------MailingAddress------------------------------------------------
          debugger;
          self.IsShowMailingAddress =
            response.data.MailingAddress.IsShowMailingAddress;
          self.IsMailingAddressMandatory =
            response.data.MailingAddress.IsMailingAddressMandatory;
          self.MailingAddressLabel =
            response.data.MailingAddress.MailingAddressLabel;
          //---------------------City------------------------------------------------
          self.IsShowCity = response.data.City.IsShowCity;
          self.IsCityMandatory = response.data.City.IsCityMandatory;
          self.CityDisplayLabel = response.data.City.CityDisplayLabel;
          //---------------------Zip------------------------------------------------
          self.IsShowZip = response.data.Zip.IsShowZip;
          self.IsZipMandatory = response.data.Zip.IsZipMandatory;
          self.ZipDisplayLabel = response.data.Zip.ZipDisplayLabel;
          //---------------------State------------------------------------------------

          /***************************************************/
          debugger;
          console.log(
            "IsEnabledState from json file " +
              response.data.State.IsEnabledState
          );
          self.IsEnabledState =
            response.data.State.IsEnabledState == undefined
              ? true
              : response.data.State.IsEnabledState;
          console.log("IsEnabledState2 " + self.IsEnabledState);
          /***************************************************/
          self.IsShowOtherStateTextBox =
            response.data.State.IsShowOtherStateTextBox;
          self.IsShowOtherState = response.data.State.IsShowOtherState;
          self.IsStateMandatory = response.data.State.IsStateMandatory;
          self.StateDisplayLabel = response.data.State.StateDisplayLabel;
          self.OtherStateDisplayLabel =
            response.data.State.OtherStateDisplayLabel;
          debugger;
          //-------------------------------------------------------------------------------------
          self.GetStatesLoadTime();
        });
      });
    },
    onFileChange(e) {
      self.userUpdated = false;
      self.attendeeUpdated = false;
      debugger;
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;

      for (var i = 0; i < files.length; i++) {
        var file = files[i];
        var metadata = {
          contentType: file.type,
        };

        const validImageTypes = ["image/gif", "image/jpeg", "image/png"];
        if (!validImageTypes.includes(file.type)) {
          alert("Only gif,jpeg & png file allowed.");
          return false;
        }

        $(".loader-profile").addClass("show");

        storageRef
          .storage()
          .ref()
          .child(
            self.eventcollectionname +
              "/Attendees/" +
              "REG" +
              "_" +
              new Date().getTime() +
              "_" +
              file.name
          )
          .put(file, metadata)
          .then(function (snapshot) {
            snapshot.ref
              .getDownloadURL()
              .then(function (imgURL) {
                self.uploadedProfilePicturePath = imgURL;
              })
              .then(() => {
                console.log("Successfully uploaded the profilepic");
              })
              .catch((error) => {
                console.error(
                  "There was an error editing the profilepic: " + error
                );
              });
          })
          .catch(function (error) {
            console.error("profilepic Upload failed:", error);
          });
      }
    },
    GetStatesLoadTime: function () {
      if (self.IsEnabledState) {
        var dropCountry = document.getElementById("dropCountry");
        var strCountry = dropCountry.options[dropCountry.selectedIndex].value;

        debugger;
        var evntCol = "OA_UAT_" + self.clientID + self.evntId;
        const storage = firebase.storage();
        const storageRef = storage.ref();
        const objStaticFieldRef = storageRef.child(
          evntCol + "/Registration/DefaultRegFormSettings.JSON"
        );

        objStaticFieldRef.getDownloadURL().then((url) => {
          axios.get(url).then((response) => {
            //------------------states------------------------------------------------
            var selectedState = "";

            if (strCountry == "United States") {
              selectedState = response.data.State.USAStateList;
              self.IsShowStateList = true;
              self.IsShowOtherStateTextBox = false;
              document.getElementById("txtOtherState").disabled = "true";
              document.getElementById("txtOtherState").style.display = "none";
              document.getElementById("OtherStateLabel").style.display = "none";

              document.getElementById("txtOtherState").value = "";
            } else if (strCountry == "India") {
              selectedState = response.data.State.IndiaStateList;
              self.IsShowStateList = true;
              self.IsShowOtherStateTextBox = false;
              document.getElementById("txtOtherState").disabled = "true";
              document.getElementById("txtOtherState").style.display = "none";
              document.getElementById("OtherStateLabel").style.display = "none";
              document.getElementById("txtOtherState").value = "";
            } else if (strCountry == "United Kingdom") {
              selectedState = response.data.State.UKStateList;
              self.IsShowStateList = true;
              self.IsShowOtherStateTextBox = false;
              document.getElementById("txtOtherState").disabled = "true";
              document.getElementById("txtOtherState").style.display = "none";
              document.getElementById("OtherStateLabel").style.display = "none";
              document.getElementById("txtOtherState").value = "";
            } else if (strCountry == "United Arab Emirates") {
              selectedState = response.data.State.UAEStates;
              self.IsShowStateList = true;
              self.IsShowOtherStateTextBox = false;
              document.getElementById("txtOtherState").disabled = "true";
              document.getElementById("txtOtherState").style.display = "none";
              document.getElementById("OtherStateLabel").style.display = "none";
              document.getElementById("txtOtherState").value = "";
            } else if (strCountry == "Singapore") {
              selectedState = response.data.State.SingaporeStateList;
              self.IsShowStateList = true;
              self.IsShowOtherStateTextBox = false;
              document.getElementById("txtOtherState").disabled = "true";
              document.getElementById("txtOtherState").style.display = "none";
              document.getElementById("OtherStateLabel").style.display = "none";
              document.getElementById("txtOtherState").value = "";
            } else {
              selectedState = "";
              self.IsShowOtherStateTextBox = true;
              self.IsShowStateList = false;
              document.getElementById("txtOtherState").disabled = false;
              document.getElementById("dropState").options.length = 0;

              document.getElementById("txtOtherState").style.display = "block";
              document.getElementById("OtherStateLabel").style.display =
                "block";
              document.getElementById("txtOtherState").value = "";
            }

            var stateOptions;
            if (selectedState != undefined) {
              if (selectedState.length > 0) {
                stateOptions = selectedState.split(",");
              }

              var selectCountry = document.getElementById("dropState");
              if (stateOptions != undefined) {
                document.getElementById("dropState").options.length = 0;
                for (var j = stateOptions.length - 1; j >= 0; j--) {
                  var optionCountry = document.createElement("option");
                  optionCountry.text = optionCountry.value = stateOptions[j];
                  selectCountry.add(optionCountry, 0);
                }
                $("select option:first-child").attr("selected", "selected");
              }
            }
          });
        });
      } else {
        self.IsShowStateList = false;
        self.IsShowOtherStateTextBox = false;
      }
    },
    GetStates: function (event) {
      var evntCol = "OA_UAT_" + self.clientID + self.evntId;
      const storage = firebase.storage();
      const storageRef = storage.ref();
      const objStaticFieldRef = storageRef.child(
        evntCol + "/Registration/DefaultRegFormSettings.JSON"
      );

      objStaticFieldRef.getDownloadURL().then((url) => {
        axios.get(url).then((response) => {
          //------------------states------------------------------------------------
          var selectedState = "";

          if (event.target.value == "United States") {
            selectedState = response.data.State.USAStateList;
            self.IsShowStateList = true;
            self.IsShowOtherStateTextBox = false;
            document.getElementById("txtOtherState").disabled = "true";
            document.getElementById("txtOtherState").style.display = "none";
            document.getElementById("OtherStateLabel").style.display = "none";

            document.getElementById("txtOtherState").value = "";
          } else if (event.target.value == "India") {
            selectedState = response.data.State.IndiaStateList;
            self.IsShowStateList = true;
            self.IsShowOtherStateTextBox = false;
            document.getElementById("txtOtherState").disabled = "true";
            document.getElementById("txtOtherState").style.display = "none";
            document.getElementById("OtherStateLabel").style.display = "none";
            document.getElementById("txtOtherState").value = "";
          } else if (event.target.value == "United Kingdom") {
            selectedState = response.data.State.UKStateList;
            self.IsShowStateList = true;
            self.IsShowOtherStateTextBox = false;
            document.getElementById("txtOtherState").disabled = "true";
            document.getElementById("txtOtherState").style.display = "none";
            document.getElementById("OtherStateLabel").style.display = "none";
            document.getElementById("txtOtherState").value = "";
          } else if (event.target.value == "United Arab Emirates") {
            selectedState = response.data.State.UAEStates;
            self.IsShowStateList = true;
            self.IsShowOtherStateTextBox = false;
            document.getElementById("txtOtherState").disabled = "true";
            document.getElementById("txtOtherState").style.display = "none";
            document.getElementById("OtherStateLabel").style.display = "none";
            document.getElementById("txtOtherState").value = "";
          } else if (event.target.value == "Singapore") {
            selectedState = response.data.State.SingaporeStateList;
            self.IsShowStateList = true;
            self.IsShowOtherStateTextBox = false;
            document.getElementById("txtOtherState").disabled = "true";
            document.getElementById("txtOtherState").style.display = "none";
            document.getElementById("OtherStateLabel").style.display = "none";
            document.getElementById("txtOtherState").value = "";
          } else {
            selectedState = "";
            self.IsShowOtherStateTextBox = true;
            self.IsShowStateList = false;
            document.getElementById("txtOtherState").disabled = false;
            document.getElementById("dropState").options.length = 0;

            document.getElementById("txtOtherState").style.display = "block";
            document.getElementById("OtherStateLabel").style.display = "block";
            document.getElementById("txtOtherState").value = "";
          }

          console.log("IsEnabledState1 - " + self.IsEnabledState);

          /************************************************************ */
          if (self.IsEnabledState == false) {
            self.IsShowOtherStateTextBox = false;
            self.IsShowStateList = false;
          }
          /************************************************************ */
          var stateOptions;
          if (selectedState != undefined) {
            if (selectedState.length > 0) {
              stateOptions = selectedState.split(",");
            }

            var selectCountry = document.getElementById("dropState");
            if (stateOptions != undefined) {
              document.getElementById("dropState").options.length = 0;
              for (var j = stateOptions.length - 1; j >= 0; j--) {
                var optionCountry = document.createElement("option");
                optionCountry.text = optionCountry.value = stateOptions[j];
                selectCountry.add(optionCountry, 0);
              }
              $("select option:first-child").attr("selected", "selected");
            }
          }
        });
      });
    },
    HideDropdown: function () {
      $("#checkboxes").hide();
      self.expanded = false;
    },
    calc: function () {
      var cnt = 0;
      $("input:checkbox[name=specialization]:checked").each(function () {
        cnt++;
      });
      document.getElementById("dvspecialization").innerText = cnt + " Selected";
    },
    checkMobileLength: function () {
      var txtMobilenumber = document.getElementById("txtMobilenumber").value;

      if (txtMobilenumber.length > 10) {
        document.getElementById("dvOtherMsg").innerText =
          "Mobile number cant be more than 10 digit.";
        $("#Othermsg-modal").modal("show");
        document.getElementById("txtMobilenumber").value = "";
        return false;
      }
    },
    goForLandingPage: function () {
      if (!refererPath || refererPath == "/") {
        router.push({
          path: "/event/" + self.evntId,
        });
      } else {
        router.push(refererPath);
      }
    },
    goForEventList: function () {
      router.push({
        path: "/register/" + self.clientID,
      });
    },
    goForLogin: function () {
      router.push({ name: "Login" });
    },
    getButtonBranding: function (hostName) {
      var path;
      if (hostName.toLowerCase().indexOf("uat") > -1) {
        path = "https://resources.e2m.live/uate2monair.appspot.com/";
      } else {
        path = APIs.googleSoragePath;
      }
      axios
        .get(
          path + "OA_UAT%2FClients%2FHosts%2F" + hostName + ".json?alt=media"
        )
        .then((res) => {
          debugger;
          self.btnBackColor = res.data.LoginAssets.loginButtonFillColor;
          self.btntextColor = res.data.LoginAssets.loginButtonTextColor;
          //$("#btnRegister").css("background-color", self.btnBackColor);
          //$("#btnRegister").css("color", self.btntextColor);

          $("#btnStripePayment").css("background-color", self.btnBackColor);
          $("#btnStripePayment").css("color", self.btntextColor);
        });
      //------------------------------------------------------------------------------
    },
    clearform: function () {
      if (confirm("Are you sure to clear the form?")) {
        var elements = document.getElementsByTagName("input");
        for (var ii = 0; ii < elements.length; ii++) {
          if (elements[ii].type == "text") {
            elements[ii].value = "";
          }
          if (elements[ii].type == "number") {
            elements[ii].value = "";
          }
          if (elements[ii].type == "email") {
            elements[ii].value = "";
          }
          if (elements[ii].type == "file") {
            elements[ii].value = "";
          }
          document.getElementById("dvspecialization").innerText = "Select One";
        }
        $('input[type="checkbox"]:checked').prop("checked", false);
      }
    },
    showCheckboxes: function (e) {
      var checkboxes = document.getElementById("checkboxes");
      if (!self.expanded) {
        checkboxes.style.display = "block";
        self.expanded = true;
      } else {
        checkboxes.style.display = "none";
        self.expanded = false;
      }
      e.stopPropagation();
    },
    HideShowcheckboxSelect: function (e) {
      e.stopPropagation();
    },
    getTermsAndConditionsFields: function () {
      debugger;
      var evntCol = "OA_UAT_" + self.clientID + self.evntId;
      const storage = firebase.storage();
      const storageRef = storage.ref();
      const objStaticFieldRef = storageRef.child(
        evntCol + "/Registration/PreSignupTerms.json"
      );

      objStaticFieldRef.getDownloadURL().then((url) => {
        debugger;
        axios.get(url).then((response) => {
          //------------------Presignup terms------------------------------------------------
          if (response.data.PreSignupTerms.HTMLbody != undefined) {
            self.HTMLbody = response.data.PreSignupTerms.HTMLbody;
          }
          if (response.data.PreSignupTerms.RequireAcceptance != undefined) {
            self.RequirePresignupAcceptance =
              response.data.PreSignupTerms.RequireAcceptance;
          }

          if (response.data.PreSignupTerms.OptInOne != undefined) {
            self.OptInOne = response.data.PreSignupTerms.OptInOne;
          }

          if (response.data.PreSignupTerms.OptInOneIsRequired != undefined) {
            self.OptInOneIsRequired =
              response.data.PreSignupTerms.OptInOneIsRequired;
          }
          if (response.data.PreSignupTerms.OptInTwo != undefined) {
            self.OptInTwo = response.data.PreSignupTerms.OptInTwo;
          }

          if (response.data.PreSignupTerms.OptInTwoIsRequired != undefined) {
            self.OptInTwoIsRequired =
              response.data.PreSignupTerms.OptInTwoIsRequired;
          }
          if (
            response.data.PreSignupTerms.AcceptanceValidationDisplayLabel !=
            undefined
          ) {
            self.AcceptanceValidationDisplayLabel =
              response.data.PreSignupTerms.AcceptanceValidationDisplayLabel;
          }

          if (response.data.PreSignupTerms.AcceptanceDisplayText != undefined) {
            self.AcceptanceDisplayText =
              response.data.PreSignupTerms.AcceptanceDisplayText;
          }
        });
      });
    },

    getDynamicFields: function () {
      var evntCol = "OA_UAT_" + self.clientID + self.evntId;
      if (self.getDynamincfieldsFromDB) {
        self.getDynamicFieldsFromDB();
      } else {
        const storage = firebase.storage();
        const storageRef = storage.ref();
        const objectCSSRef = storageRef.child(
          evntCol + "/Registration/FormBuilderReg.json"
        );

        self.shortforCSSClass = "small-form";

        objectCSSRef
          .getDownloadURL()
          .then((url) => {
            axios.get(url).then((response) => {
              debugger;
              self.FormJson = response.data;
              self.fields = response.data;
              /*self.FormJson.map((x) => {
                  DynamicInputs[x.cid.split(" ").join("").toLowerCase()] = "";
              });*/
              self.SubmitButtonText1 = "Send Feedback";
              let arr = [];
              self.shortforCSSClass = "";
              self.fields.map((x) => {
                if (x.field_type == "text") {
                  let obj = {};
                  obj["id"] = x.cid;
                  obj["type"] = "input";
                  obj["inputType"] = "text";
                  obj["label"] = x.label;
                  obj["model"] = x.cid.split(" ").join("").toLowerCase();
                  obj["required"] = x.required;
                  obj["readonly"] = false;
                  obj["featured"] = true;
                  obj["disabled"] = false;
                  obj["placeholder"] = x.label;
                  obj["description"] = x.field_options.description;
                  obj["validator"] = VueFormGenerator.validators.string;

                  arr.push(obj);
                }

                if (x.field_type == "email") {
                  let obj = {};
                  obj["id"] = x.cid;
                  obj["type"] = "input";
                  obj["inputType"] = "email";
                  obj["label"] = x.label;
                  obj["model"] = x.cid.split(" ").join("").toLowerCase();
                  obj["required"] = x.required;
                  obj["readonly"] = false;
                  obj["featured"] = true;
                  obj["disabled"] = false;
                  obj["placeholder"] = x.label;
                  obj["description"] = x.field_options.description;
                  obj["validator"] = VueFormGenerator.validators.email;

                  arr.push(obj);
                }

                if (x.field_type == "paragraph") {
                  let obj = {};
                  obj["id"] = x.cid;
                  obj["label"] = x.label;
                  obj["class"] = "clstest";
                  obj["model"] = x.cid.split(" ").join("").toLowerCase();
                  obj["required"] = x.required;
                  obj["readonly"] = false;
                  obj["featured"] = true;
                  obj["disabled"] = false;
                  obj["placeholder"] = x.label;
                  obj["description"] = x.field_options.description;
                  obj["min"] = 0;
                  obj["validator"] = VueFormGenerator.validators.number;
                  arr.push(obj);
                }

                if (x.field_type == "dropdown") {
                  let obj = {},
                    sel = { hideNoneSelectedText: true };
                  obj["id"] = x.cid;
                  obj["type"] = "select";
                  obj["inputType"] = "text";
                  obj["label"] = x.label;
                  obj["model"] = x.cid.split(" ").join("").toLowerCase();
                  obj["required"] = x.required;
                  obj["readonly"] = false;
                  obj["featured"] = true;
                  obj["disabled"] = false;
                  obj["placeholder"] = x.label;
                  obj["description"] = x.field_options.description;
                  obj["selectOptions"] = sel;
                  let list = [];
                  x.field_options.options.map((y) => {
                    list.push(y.label);
                  });
                  obj["values"] = list;
                  arr.push(obj);
                }

                if (x.field_type == "radio") {
                  let obj = {},
                    sel = { hideNoneSelectedText: true };
                  obj["id"] = x.cid;
                  obj["type"] = "radios";
                  obj["label"] = x.label;
                  obj["model"] = x.cid.split(" ").join("").toLowerCase();
                  obj["required"] = x.required;
                  obj["readonly"] = false;
                  obj["featured"] = true;
                  obj["disabled"] = false;
                  obj["placeholder"] = "";
                  obj["selectOptions"] = sel;
                  let list = [];

                  x.field_options.options.map((y) => {
                    var item = {};
                    item.optionLabel = y.label;
                    item.optionValue = y.label;
                    list.push(y.label);
                  });
                  obj["values"] = list;
                  arr.push(obj);
                }

                if (x.field_type == "checkboxes") {
                  let obj = {},
                    sel = { hideNoneSelectedText: false };
                  obj["id"] = x.cid;
                  obj["type"] = "checklist";
                  obj["label"] = x.label;
                  obj["model"] = x.cid.split(" ").join("").toLowerCase();
                  obj["required"] = x.required;
                  obj["readonly"] = false;
                  obj["featured"] = true;
                  obj["disabled"] = false;
                  obj["placeholder"] = "";
                  obj["selectOptions"] = sel;
                  let list = [];
                  x.field_options.options.map((y) => {
                    list.push(y.label);
                  });
                  obj["values"] = list;
                  obj["multi"] = true;
                  obj["multiSelect"] = true;
                  arr.push(obj);
                }

                if (x.field_type == "file") {
                  let obj = {};
                  obj["type"] = "input";
                  obj["inputType"] = "file";
                  obj["label"] = x.label;
                  obj["model"] = "file";
                  obj["featured"] = true;
                  obj["v-on:change"] = "uploadFile";
                  arr.push(obj);
                }

                if (x.field_type == "phone") {
                  let obj = {};
                  obj["id"] = x.cid;
                  obj["type"] = "input";
                  obj["inputType"] = "text";
                  obj["label"] = x.label;
                  obj["model"] = x.cid.split(" ").join("").toLowerCase();
                  obj["required"] = x.required;
                  obj["readonly"] = false;
                  obj["featured"] = true;
                  obj["disabled"] = false;
                  obj["placeholder"] = x.label;
                  obj["description"] = x.field_options.description;
                  obj["validator"] = VueFormGenerator.validators.string;

                  arr.push(obj);
                }
              });
              self.schema.fields = arr;
            });
          })
          .catch((error) => {
            //alert(error);
            console.log(error);
          });
      }
    },
    getDynamicFieldsFromDB: function () {
      var evntCol = "OA_UAT_" + self.clientID + self.evntId;
      var docRef = db
        .collection(evntCol)
        .doc("FormList")
        .collection("Forms")
        .doc(self.FormId);
      docRef
        .get()
        .then(function (doc) {
          if (doc.exists) {
            self.shortforCSSClass = "";
            debugger;
            self.FormTitle = doc.data().FormTitle;
            self.FormJson = doc.data().FormJson;
            self.fields = doc.data().FormJson;
            console.log("FieldsFrom DB:- " + JSON.stringify(self.fields));
            /*self.FormJson.map((x) => {
                DynamicInputs[x.cid.split(" ").join("").toLowerCase()] = "";
            });*/
            self.SubmitButtonText1 = doc.data().SubmitButtonText;

            let arr = [];
            self.fields.map((x) => {
              if (x.field_type == "text") {
                let obj = {};
                obj["id"] = x.cid;
                obj["type"] = "input";
                obj["inputType"] = "text";
                obj["label"] = x.label;
                obj["model"] = x.cid.split(" ").join("").toLowerCase();
                obj["required"] = x.required;
                obj["readonly"] = false;
                obj["featured"] = true;
                obj["disabled"] = false;
                obj["placeholder"] = x.label;
                obj["description"] = x.field_options.description;
                obj["validator"] = VueFormGenerator.validators.string;

                arr.push(obj);
              }

              if (x.field_type == "email") {
                let obj = {};
                obj["id"] = x.cid;
                obj["type"] = "input";
                obj["inputType"] = "email";
                obj["label"] = x.label;
                obj["model"] = x.cid.split(" ").join("").toLowerCase();
                obj["required"] = x.required;
                obj["readonly"] = false;
                obj["featured"] = true;
                obj["disabled"] = false;
                obj["placeholder"] = x.label;
                obj["description"] = x.field_options.description;
                obj["validator"] = VueFormGenerator.validators.email;

                arr.push(obj);
              }

              if (x.field_type == "paragraph") {
                let obj = {};
                obj["id"] = x.cid;
                obj["label"] = x.label;
                obj["class"] = "clstest";
                obj["model"] = x.cid.split(" ").join("").toLowerCase();
                obj["required"] = x.isRequired;
                obj["readonly"] = false;
                obj["featured"] = true;
                obj["disabled"] = false;
                obj["placeholder"] = x.label;
                obj["description"] = x.field_options.description;
                obj["min"] = 0;
                obj["validator"] = VueFormGenerator.validators.number;

                arr.push(obj);
              }

              if (x.field_type == "dropdown") {
                let obj = {},
                  sel = { hideNoneSelectedText: true };
                obj["id"] = x.cid;
                obj["type"] = "select";
                obj["inputType"] = "text";
                obj["label"] = x.label;
                obj["model"] = x.cid.split(" ").join("").toLowerCase();
                obj["required"] = x.required;
                obj["readonly"] = false;
                obj["featured"] = true;
                obj["disabled"] = false;
                obj["placeholder"] = x.label;
                obj["description"] = x.field_options.description;
                obj["selectOptions"] = sel;
                let list = [];
                x.field_options.options.map((y) => {
                  list.push(y.label);
                });
                obj["values"] = list;
                arr.push(obj);
              }

              if (x.field_type == "radio") {
                let obj = {};
                let sel = { hideNoneSelectedText: true };
                obj["id"] = x.cid;
                obj["type"] = "radios";
                obj["label"] = x.label;
                obj["model"] = x.cid.split(" ").join("").toLowerCase();
                obj["required"] = x.isRequired;
                obj["readonly"] = false;
                obj["featured"] = true;
                obj["disabled"] = false;
                obj["placeholder"] = "";
                obj["selectOptions"] = sel;
                let list = [];

                x.field_options.options.map((y) => {
                  var item = {};
                  item.optionLabel = y.label;
                  item.optionValue = y.label;
                  list.push(y.label);
                });
                obj["values"] = list;
                arr.push(obj);
              }

              if (x.field_type == "checkboxes") {
                let obj = {},
                  sel = { hideNoneSelectedText: false };
                obj["id"] = x.cid;
                obj["type"] = "checklist";
                obj["label"] = x.label;
                obj["model"] = x.cid.split(" ").join("").toLowerCase();
                obj["required"] = x.isRequired;
                obj["readonly"] = false;
                obj["featured"] = true;
                obj["disabled"] = false;
                obj["placeholder"] = "";
                obj["selectOptions"] = sel;
                let list = [];
                x.field_options.options.map((y) => {
                  list.push(y.label);
                });
                obj["values"] = list;
                obj["multi"] = true;
                obj["multiSelect"] = true;
                arr.push(obj);
              }
              if (x.field_type == "file") {
                let obj = {};
                obj["type"] = "input";
                obj["inputType"] = "file";
                obj["label"] = x.label;
                obj["model"] = "file";
                obj["featured"] = true;
                obj["v-on:change"] = "uploadFile";

                arr.push(obj);
              }
            });
            self.schema.fields = arr;
          } else {
            self.shortforCSSClass = "small-form";
          }
        })
        .catch(function (error) {
          console.log("Error fetching Survey Form:", error);
        });
    },

    uploadFile: function () {
      alert("upload");
    },
    GetTimeByZone: function (strDateTime, timeZone) {
      strDateTime = moment(strDateTime).format("YYYY-MM-DD HH:mm");
      var strtDate = moment.tz(strDateTime, timeZone);
      strtDate._d.setMinutes(strtDate._d.getMinutes() - strtDate._offset);
      return strtDate._d;
    },
    restrictChars: function ($event) {
      return (
        $event.charCode === 0 || /\d/.test(String.fromCharCode($event.charCode))
      );
    },
    validateEmailType: function () {
      var email = document.getElementById("txtEmail").value;

      email = email.toLowerCase();
      if (email != "") {
        document.getElementById("dvOtherMsg").innerText = "";
        if (!self.reg.test(email)) {
          document.getElementById("dvOtherMsg").innerText =
            "Wrong email format, please enter proper email.";
          $("#Othermsg-modal").modal("show");
          return false;
        }
      } else {
        return false;
      }
    },
    checkEmail: function () {
      var email = document.getElementById("txtEmail").value;
      document.getElementById("dvOtherMsg").innerText = "";
      if (email.trim() == "") {
        return false;
      }
      email = email.toLowerCase();
      if (!self.reg.test(email)) {
        document.getElementById("dvOtherMsg").innerText =
          "Wrong email format, please enter proper email.";
        $("#Othermsg-modal").modal("show");
        return false;
      }
      var postData = {
        key: {
          instanceId: "OA_UAT",
          clientId: self.clientID.toString(),
          eventId: parseInt(self.evntId.replace("E", "")),
        },
        data: {
          Email: email,
        },
      };
      self.showLoader();
      let headers = {
        "Content-Type": "application/json",
        "x-api-key": APIs.XAPIkey,
      };
      axios
        .post(APIs.ValidateEventAttendeeReg, JSON.stringify(postData), {
          headers: headers,
        })
        .then((response) => {
          if (response.data.regValidationResult == -20) {
            self.hideLoader();
            document.getElementById("dvOtherMsg").innerText =
              "This email is already registered, please sign-up with a different email.";
            $("#Othermsg-modal").modal("show");
            document.getElementById("txtEmail").value = "";
            document.getElementById("txtFName").value = "";
            document.getElementById("txtLName").value = "";
            document.getElementById("txtCompanyName").value = "";
            document.getElementById("txtTitle").value = "";
            return false;
          } else {
            self.hideLoader();
          }
        })
        .catch((error) => {
          console.log(error);
          self.hideLoader();

          alert("Error in registration process,please try again later.");
        });
    },
    SaveUserRegistration: function () {
      /********************************************************************** */
      /*for only PAYMENT testing purpose when we no need to register again and again.STRONGLY 
      recommend this section to be COMMENTED BEFORE COMMIT */

      // if (self.FormType.toLowerCase() == "paid") {
      //   $("#payment-popup").modal("show");
      // }
      /********************************************************************** */
      debugger;
      var email = document.getElementById("txtEmail").value;
      var fName = document.getElementById("txtFName").value;
      var lname = document.getElementById("txtLName").value;
      var CompanyName = document.getElementById("txtCompanyName").value;
      var designation = document.getElementById("txtDesignation").value;
      var mobilenumber = "";
      if (!self.showMobileCountryCode) {
        self.IsValidMobilenumber = true;
        mobilenumber = document.getElementById("txtMobilenumber").value;
      } else {
        mobilenumber = self.MobilenumberWithCountryCode;
        if (!mobilenumber) {
          mobilenumber = "";
        }
      }

      self.customerEmail = email;
      self.RegTicketType = "";

      if (self.IsfNameMandatory) {
        if (fName.trim() == "") {
          // document.getElementById("dvOtherMsg").innerText =
          //   self.firstNameDisplayLabel + " is mandatory.";
          // $("#Othermsg-modal").modal("show");
          self.showSnackbar(
            self.firstNameDisplayLabel + " is mandatory.",
            "error",
            "top"
          );
          document.getElementById("txtFName").focus();
          return false;
        }
      }
      if (self.IslNameMandatory) {
        if (lname.trim() == "") {
          // document.getElementById("dvOtherMsg").innerText =
          //   self.lastNameDisplayLabel + " is mandatory.";
          // $("#Othermsg-modal").modal("show");

          self.showSnackbar(
            self.lastNameDisplayLabel + " is mandatory.",
            "error",
            "top"
          );
          document.getElementById("txtLName").focus();
          return false;
        }
      }
      if (self.IsEmailMandatory) {
        if (email.trim() == "") {
          // document.getElementById("dvOtherMsg").innerText =
          //   self.emailDisplayLabel + " is mandatory.";
          // $("#Othermsg-modal").modal("show");
          self.showSnackbar(
            self.emailDisplayLabel + " is mandatory.",
            "error",
            "top"
          );
          document.getElementById("txtEmail").focus();
          return false;
        }
      }
      if (self.IsProfilePictureMandatory) {
        if (document.getElementById("fuProfile").value == "") {
          // document.getElementById("dvOtherMsg").innerText =
          //   self.ProfilePictureDisplayLabel + " is mandatory.";
          // $("#Othermsg-modal").modal("show");
          self.showSnackbar(
            self.ProfilePictureDisplayLabel + " is mandatory.",
            "error",
            "top"
          );

          return false;
        }
      }

      if (self.IsCompanyMandatory) {
        if (CompanyName.trim() == "") {
          // document.getElementById("dvOtherMsg").innerText =
          //   self.companyDisplayLabel + " is mandatory.";
          // $("#Othermsg-modal").modal("show");
          self.showSnackbar(
            self.companyDisplayLabel + " is mandatory.",
            "error",
            "top"
          );
          document.getElementById("txtCompanyName").focus();
          return false;
        }
      }
      if (self.IsTitleMandatory) {
        if (designation.trim() == "") {
          // document.getElementById("dvOtherMsg").innerText =
          //   self.TitleDisplayLabel + " is mandatory.";
          // $("#Othermsg-modal").modal("show");
          self.showSnackbar(
            self.TitleDisplayLabel + " is mandatory.",
            "error",
            "top"
          );
          document.getElementById("txtDesignation").focus();
          return false;
        }
      }
      debugger;
      if (self.IsMobileMandatory) {
        if (mobilenumber.trim() == "") {
          // document.getElementById("dvOtherMsg").innerText =
          //   self.mobileDisplayLabel + " number is mandatory.";
          // $("#Othermsg-modal").modal("show");
          self.showSnackbar(
            self.mobileDisplayLabel + " is mandatory.",
            "error",
            "top"
          );
          document.getElementById("txtMobilenumber").focus();
          return false;
        } else if (!self.IsValidMobilenumber) {
          self.showSnackbar(
            self.mobileDisplayLabel + " is mandatory.",
            "error",
            "top"
          );
          document.getElementById("txtMobilenumber").focus();
          return false;
        }
      }
      //-----------------------------------------------------------------------------------------------------
      var strSalutation = "";
      if (self.IsShowSalutation) {
        var dropsalutation = document.getElementById("dropsalutation");
        strSalutation =
          dropsalutation.options[dropsalutation.selectedIndex].value;
      }
      //-----------------------------------------------------------------------------------------------------
      var strRegtype = "";
      var colorCode = "";
      if (self.IsShowRegFormType) {
        var dropRegType = document.getElementById("dropRegType");
        strRegtype = dropRegType.options[dropRegType.selectedIndex].text;
        colorCode =
          dropRegType.options[dropRegType.selectedIndex].getAttribute(
            "datacolor"
          );

        if (
          strRegtype.trim() == "" ||
          strRegtype.trim().toLowerCase() == "select an option"
        ) {
          // document.getElementById("dvOtherMsg").innerText =
          //   "Please select " + self.RegTypeDisplayLabel + ", it is mandatory.";
          // $("#Othermsg-modal").modal("show");
          self.showSnackbar(
            self.RegTypeDisplayLabel + " is mandatory.",
            "error",
            "top"
          );
          document.getElementById("txt100").focus();
          return false;
        }
      }
      //------------------------------MailingAddress-----------------------------------------------------------------------
      var txtMailingAddress = "";
      if (self.IsShowMailingAddress) {
        txtMailingAddress = document.getElementById("txtMailingAddress").value;
        if (txtMailingAddress.trim() == "") {
          // document.getElementById("dvOtherMsg").innerText =
          //   self.MailingAddressLabel + " is mandatory.";
          // $("#Othermsg-modal").modal("show");
          self.showSnackbar(
            self.MailingAddressLabel + " is mandatory.",
            "error",
            "top"
          );
          document.getElementById("txtMailingAddress").focus();
          return false;
        }
      }
      //---------------------------Country--------------------------------------------------------------------------
      var strCountry = "";
      if (self.IsShowCountryList) {
        var dropCountry = document.getElementById("dropCountry");
        strCountry = dropCountry.options[dropCountry.selectedIndex].value;

        if (
          strCountry.trim() == "" ||
          strCountry.trim().toLowerCase() == "select an option"
        ) {
          // document.getElementById("dvOtherMsg").innerText =
          //   "Please select " + self.CountryDisplayLabel + ", it is mandatory.";
          // $("#Othermsg-modal").modal("show");
          self.showSnackbar(
            self.CountryDisplayLabel + " is mandatory.",
            "error",
            "top"
          );
          document.getElementById("txt100").focus();
          return false;
        }
      }
      //------------------------------OtherState-----------------------------------------------------------------------

      var txtOtherState = "";
      var strSelectedState = "";

      if (self.IsShowStateList) {
        var dropState = document.getElementById("dropState");
        if (dropState.selectedIndex >= 0) {
          strSelectedState = dropState.options[dropState.selectedIndex].value;
        }
      }

      if (self.IsShowOtherStateTextBox) {
        txtOtherState = document.getElementById("txtOtherState").value;
      }

      if (
        strSelectedState == "" ||
        strSelectedState.trim().toLowerCase() == "select an option"
      ) {
        if (self.IsShowOtherStateTextBox) {
          if (txtOtherState.trim() == "") {
            // document.getElementById("dvOtherMsg").innerText =
            //   "Please Select Either " +
            //   self.StateDisplayLabel +
            //   " Or Provide " +
            //   self.OtherStateDisplayLabel;
            // $("#Othermsg-modal").modal("show");
            self.showSnackbar(
              "Please Select Either " +
                self.StateDisplayLabel +
                " Or Provide " +
                self.OtherStateDisplayLabel,
              "error",
              "top"
            );
            document.getElementById("txtOtherState").focus();
            return false;
          }
        } else if (self.IsShowStateList) {
          // document.getElementById("dvOtherMsg").innerText =
          //   "Please Select Either " +
          //   self.StateDisplayLabel +
          //   " Or Provide " +
          //   self.OtherStateDisplayLabel;
          // $("#Othermsg-modal").modal("show");
          self.showSnackbar(
            "Please Select Either " +
              self.StateDisplayLabel +
              " Or Provide " +
              self.OtherStateDisplayLabel,
            "error",
            "top"
          );
          document.getElementById("txtOtherState").focus();
          return false;
        }
      }
      //------------------------------City-----------------------------------------------------------------------
      var txt101 = "";
      if (self.IsShowCity) {
        txt101 = document.getElementById("txt101").value;
        if (txt101.trim() == "") {
          // document.getElementById("dvOtherMsg").innerText =
          //   self.CityDisplayLabel + " is mandatory.";
          // $("#Othermsg-modal").modal("show");
          self.showSnackbar(
            "Please Select Either " + self.CityDisplayLabel + " is mandatory.",
            "error",
            "top"
          );
          document.getElementById("txt101").focus();
          return false;
        }
      }
      //-----------------------------Zip------------------------------------------------------------------------
      var txt100 = "";
      if (self.IsShowZip) {
        txt100 = document.getElementById("txt100").value;
        if (txt100.trim() == "") {
          // document.getElementById("dvOtherMsg").innerText =
          //   self.ZipDisplayLabel + " is mandatory.";
          // $("#Othermsg-modal").modal("show");
          self.showSnackbar(
            self.ZipDisplayLabel + " is mandatory.",
            "error",
            "top"
          );
          document.getElementById("txt100").focus();
          return false;
        }
      }

      //}
      //-----------------------------------------------------------------------------------------------------

      // loop over them all

      //-------------------------------------------------------------------------------
      var tags = "";
      $("input:checkbox[name=specialization]:checked").each(function () {
        tags = tags + "," + $(this).val().trim();
      });

      if (tags != "") {
        if (tags.endsWith(",")) {
          tags = tags.substring(0, tags.length - 1);
        }
        if (tags.startsWith(",")) {
          tags = tags.substring(1, tags.length - 1);
        }
        tags = tags.replace(/\s/g, "");
      } else {
        if (self.IsTagsMandatory) {
          // document.getElementById("dvOtherMsg").innerText =
          //   self.tagsDisplayLabel + " is mandatory.";
          // $("#Othermsg-modal").modal("show");
          self.showSnackbar(
            self.tagsDisplayLabel + " is mandatory.",
            "error",
            "top"
          );

          return false;
        }
      }
      //---------------------------------------------------------------------------------------------------
      email = email.toLowerCase();
      console.log(self.model);
      var listRef = db
        .collection("OA_UAT/ClientList/Clients")
        .doc(self.clientID)
        .collection("Events");

      listRef
        .where("AllowRegistration", "==", true)
        .where("EventTypeId", "==", 2)
        .where("EventId", "==", self.evntId)
        .onSnapshot((querySnapshot) => {
          if (querySnapshot.docs.length > 0) {
            //+++++++++++Dynamic Registration++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
            var allInputs = {};
            var i = 0;
            for (var index in self.fields) {
              debugger;
              let field = self.fields[index];
              if (field.field_type != "checkboxes") {
                if (
                  self.model[field.cid] != undefined &&
                  self.model[field.cid] != "" &&
                  self.model[field.cid].toLowerCase() != "select an option"
                ) {
                  var input = {};
                  if (field.field_type != "paragraph") {
                    console.log("paragraph");
                  }
                  if (self.model[field.cid] != undefined) {
                    input.label = field.label;
                    input.des = field.field_options.description;
                    input.options = field.field_options.options;
                    input.field_type = field.field_type;
                  }
                  input.value = self.model[field.cid];
                  input.index = i;
                  i++;
                  allInputs[field.cid] = input;
                } else {
                  if (field.field_type != "paragraph") {
                    if (field.required) {
                      var label = field.label;
                      document.getElementById("dvOtherMsg").innerText =
                        label + " is mandatory.";
                      $("#Othermsg-modal").modal("show");
                      return false;
                    }
                  }
                }
              } else {
                if (self.model[field.cid] == undefined) {
                  if (field.required) {
                    let label2 = field.label;
                    document.getElementById("dvOtherMsg").innerText =
                      label2 + " is mandatory.";
                    $("#Othermsg-modal").modal("show");
                    return false;
                  }
                } else if (self.model[field.cid].length <= 0) {
                  if (field.required) {
                    let label2 = field.label;
                    document.getElementById("dvOtherMsg").innerText =
                      label2 + " is mandatory.";
                    $("#Othermsg-modal").modal("show");
                    return false;
                  }
                } else {
                  var input2 = {};

                  if (field.field_type != "paragraph") {
                    console.log("paragraph");
                  }
                  if (self.model[field.cid] != undefined) {
                    input2.label = field.label;
                    input2.des = field.field_options.description;
                    input2.options = field.field_options.options;
                    input2.field_type = field.field_type;
                  }
                  input2.value = self.model[field.cid];
                  input2.index = i;
                  i++;
                  allInputs[field.cid] = input2;
                }
              }
            }
            var chkTermsAndConditions = false;
            $("input:checkbox[name=TermsAndConditions]:checked").each(
              function () {
                chkTermsAndConditions = true;
              }
            );
            if (self.RequirePresignupAcceptance) {
              if (!chkTermsAndConditions) {
                // document.getElementById("dvOtherMsg").innerText =
                //   self.AcceptanceValidationDisplayLabel;
                // $("#Othermsg-modal").modal("show");

                self.showSnackbar(
                  self.AcceptanceValidationDisplayLabel,
                  "error",
                  "top"
                );

                return false;
              }
            }
            var chkOptInOne = false;
            $("input:checkbox[name=OptInONECheckBox]:checked").each(
              function () {
                chkOptInOne = true;
              }
            );
            if (self.OptInOneIsRequired) {
              if (!chkOptInOne) {
                document.getElementById("dvOtherMsg").innerText =
                  " Please select " + self.OptInOne + " - Option.";
                $("#Othermsg-modal").modal("show");

                return false;
              }
            }
            var chkOptInTwo = false;
            $("input:checkbox[name=OptInTwoCheckBox]:checked").each(
              function () {
                chkOptInTwo = true;
              }
            );
            if (self.OptInTwoIsRequired) {
              if (!chkOptInTwo) {
                document.getElementById("dvOtherMsg").innerText =
                  " Please select " + self.OptInTwo + " - Option.";
                $("#Othermsg-modal").modal("show");

                return false;
              }
            }
            var ArrPayment = [];
            var objPayment = new Object();
            debugger;
            objPayment.Status = self.PaymentStatus;
            objPayment.TransactionId = "";
            objPayment.Amount = self.ItemPrice;
            objPayment.Created = new Date();
            objPayment.Source = self.PaymentSource;
            ArrPayment.push(objPayment);
            var IssendMail = 0;
            var isRegisteredWithPayment = 0;
            if (self.FormType.toLowerCase() == "paid") {
              var dropRegType = document.getElementById("dropRegType");
              var strRegtypeValue =
                dropRegType.options[dropRegType.selectedIndex].value;
              if (strRegtypeValue == "$0") {
                IssendMail = 1;
                isRegisteredWithPayment = 0;
              } else {
                IssendMail = 0;
                isRegisteredWithPayment = 1;
              }
            } else {
              debugger;
              IssendMail = 1;
              isRegisteredWithPayment = 0;
            }
            var postData = "";
            if (isRegisteredWithPayment == 1) {
              postData = {
                sendMail: IssendMail,
                postToCRM: self.postToCRM,
                key: {
                  instanceId: "OA_UAT",
                  clientId: self.clientID.toString(),
                  eventId: parseInt(self.evntId.replace("E", "")),
                },
                data: {
                  ShowInCMSAttendeeList: 0,
                  Email: email.trim(),
                  Salutation: strSalutation.trim(),
                  FirstName: fName.trim(),
                  LastName: lname.trim(),
                  Country: strCountry.trim(),
                  Company: CompanyName.trim(),
                  Designation: designation.trim(),
                  Phone: mobilenumber.trim(),
                  Tags: tags,
                  ProfilePictureURL: self.uploadedProfilePicturePath.substring(
                    0,
                    self.uploadedProfilePicturePath.indexOf("&token")
                  ),
                  FormType: "PAID",
                  RegistrationType: {
                    RegistrationType: strRegtype.trim(),
                    ColorCode: colorCode.trim(),
                  },
                  //ColorCode: colorCode,
                  MailingAddress: txtMailingAddress.trim(),
                  City: txt101.trim(),
                  State:
                    strSelectedState.trim() != ""
                      ? strSelectedState.trim()
                      : txtOtherState.trim(),
                  Zip: txt100.trim(),
                  Payment: objPayment,
                  DynamicFields: allInputs,
                },
              };
            } else {
              postData = {
                sendMail: IssendMail,
                postToCRM: self.postToCRM,
                key: {
                  instanceId: "OA_UAT",
                  clientId: self.clientID.toString(),
                  eventId: parseInt(self.evntId.replace("E", "")),
                },
                data: {
                  ShowInCMSAttendeeList: 1,
                  Email: email.trim(),
                  Salutation: strSalutation,
                  FirstName: fName.trim(),
                  LastName: lname.trim(),
                  Country: strCountry.trim(),
                  Company: CompanyName.trim(),
                  Designation: designation.trim(),
                  Phone: mobilenumber.trim(),
                  Tags: tags,
                  ProfilePictureURL: self.uploadedProfilePicturePath.substring(
                    0,
                    self.uploadedProfilePicturePath.indexOf("&token")
                  ),
                  FormType: "FREE",
                  RegistrationType: {
                    RegistrationType: strRegtype.trim(),
                    ColorCode: colorCode.trim(),
                  },
                  //ColorCode: colorCode,
                  MailingAddress: txtMailingAddress.trim(),
                  City: txt101.trim(),
                  State:
                    strSelectedState.trim() != ""
                      ? strSelectedState.trim()
                      : txtOtherState.trim(),
                  Zip: txt100.trim(),
                  sendMail: IssendMail,
                  DynamicFields: allInputs,
                },
              };
            }
            self.email = postData.data.Email;
            self.showLoader();
            let headers = {
              "Content-Type": "application/json",
              "x-api-key": APIs.XAPIkey,
            };
            axios
              .post(APIs.RegisterEventAttendee, JSON.stringify(postData), {
                headers: headers,
              })
              .then((response) => {
                var data = response.data;
                self.hideLoader();
                if (data.regStatus == 0) {
                  if (self.FormType.toLowerCase() == "paid") {
                    var dropRegType = document.getElementById("dropRegType");
                    var strRegtype =
                      dropRegType.options[dropRegType.selectedIndex].value;
                    if (strRegtype == "$0") {
                      $("#success-modal").modal("show");
                      var elements = document.getElementsByTagName("input");
                      for (var ii = 0; ii < elements.length; ii++) {
                        if (elements[ii].type == "text") {
                          elements[ii].value = "";
                        }
                        if (elements[ii].type == "email") {
                          elements[ii].value = "";
                        }
                        if (elements[ii].type == "number") {
                          elements[ii].value = "";
                        }
                      }
                      $('input[type="checkbox"]:checked').prop(
                        "checked",
                        false
                      );
                      document.getElementById("txtEmail").value = "";
                      document.getElementById("txtFName").value = "";
                      document.getElementById("txtLName").value = "";
                      document.getElementById("txtCompanyName").value = "";
                      if (self.visitor) {
                        self.GreatClicked();
                      } else {
                        document
                          .getElementById("success-modal")
                          .addEventListener("click", function () {
                            self.GreatClicked();
                          });
                      }
                    } else {
                      $("#payment-popup").modal("show");
                    }
                  } else {
                    $("#success-modal").modal("show");
                    var elements2 = document.getElementsByTagName("input");
                    for (var ii2 = 0; ii2 < elements2.length; ii2++) {
                      if (elements2[ii2].type == "text") {
                        elements2[ii2].value = "";
                      }
                      if (elements2[ii2].type == "email") {
                        elements2[ii2].value = "";
                      }
                      if (elements2[ii2].type == "number") {
                        elements2[ii2].value = "";
                      }
                    }
                    $('input[type="checkbox"]:checked').prop("checked", false);
                    document.getElementById("txtEmail").value = "";
                    document.getElementById("txtFName").value = "";
                    document.getElementById("txtLName").value = "";
                    document.getElementById("txtCompanyName").value = "";
                    if (self.visitor) {
                      self.GreatClicked();
                    } else {
                      document
                        .getElementById("success-modal")
                        .addEventListener("click", function () {
                          self.GreatClicked();
                        });
                    }
                  }
                  return false;
                } else if (data.regStatus == -20) {
                  if (self.FormType.toLowerCase() == "paid") {
                    if (data.paymentStatus != undefined) {
                      if (data.paymentStatus == 0) {
                        $("#payment-popup").modal("show");
                      } else if (data.paymentStatus == -50) {
                        document.getElementById("dvOtherMsg").innerText =
                          "Your payment is under process, please check back in sometime.";
                        $("#Othermsg-modal").modal("show");
                        document.getElementById("txtEmail").value = "";
                        return false;
                      } else if (data.paymentStatus == -99) {
                        document.getElementById("dvOtherMsg").innerText =
                          "You have already paid for the registration.If you wish you register on behalf of someone, please register with different email ID.";
                        $("#Othermsg-modal").modal("show");
                        document.getElementById("txtEmail").value = "";
                        return false;
                      } else {
                        document.getElementById("dvOtherMsg").innerText =
                          "This email is already registered, please sign-up with a different email.";
                        $("#Othermsg-modal").modal("show");
                        document.getElementById("txtEmail").value = "";
                        return false;
                      }
                    } else {
                      document.getElementById("dvOtherMsg").innerText =
                        "This email is already registered, please sign-up with a different email.";
                      $("#Othermsg-modal").modal("show");
                      document.getElementById("txtEmail").value = "";
                      return false;
                    }
                  } else {
                    document.getElementById("dvOtherMsg").innerText =
                      "This email is already registered, please sign-up with a different email.";
                    $("#Othermsg-modal").modal("show");
                    document.getElementById("txtEmail").value = "";
                    return false;
                  }
                } else if (data.regStatus == -99) {
                  document.getElementById("dvOtherMsg").value =
                    "An Unknown error has occurred, please try again later.";
                  $("#Othermsg-modal").modal("show");
                  document.getElementById("txtEmail").value = "";
                  document.getElementById("txtFName").value = "";
                  document.getElementById("txtLName").value = "";
                  document.getElementById("txtCompanyName").value = "";

                  return false;
                } else {
                  document.getElementById("dvOtherMsg").value =
                    "An Unknown error has occurred, please try again later.";
                  $("#Othermsg-modal").modal("show");
                  document.getElementById("txtEmail").value = "";
                  document.getElementById("txtFName").value = "";
                  document.getElementById("txtLName").value = "";
                  document.getElementById("txtCompanyName").value = "";

                  return false;
                }
              })
              .catch((error) => {
                self.hideLoader();
                document.getElementById("dvOtherMsg").value =
                  "Error in registration process,please try again later. Error:" +
                  error;
                $("#Othermsg-modal").modal("show");
                document.getElementById("txtEmail").value = "";
                document.getElementById("txtFName").value = "";
                document.getElementById("txtLName").value = "";
                document.getElementById("txtCompanyName").value = "";

                return false;
              });
          } else {
            self.hideLoader();
            document.getElementById("dvOtherMsg").innerText =
              "Registration for this event is currently closed, please contact administrator.";
            $("#Othermsg-modal").modal("show");
            return false;
          }
        });
    },
    autoLoginAfterReg() {
      //alert(self.email);
      if (window.parent && $("#dialogReg", window.parent.document)) {
        $("#dialogReg", window.parent.document).attr("data-val", self.email);
        $("#dialogReg", window.parent.document).click();
      }
    },
    getCookie(cname) {
      var name = cname + "=";
      var decodedCookie = decodeURIComponent(document.cookie);
      var ca = decodedCookie.split(";");
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == " ") {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    },
    showLoader: function () {
      if ($("#divLoading") != null) {
        $("#divLoading").show();
      }
    },
    hideLoader: function () {
      clearTimeout(this.timerLoader);
      if ($("#divLoading") != null) {
        $("#divLoading").hide();
      }
    },
  },
};
</script>